(function () {
    'use strict';

    const {
      setScrollbarWidth
    } = window.PoleneLibs.Utils;
    document.addEventListener('DOMContentLoaded', () => {
      const {
        hydrateComponents
      } = window.PoleneLibs.Hydration;
      (async () => {
        const components = [Promise.resolve().then(function () { return imageLoaded$1; }), Promise.resolve().then(function () { return parallax$1; }), Promise.resolve().then(function () { return keyboardNavigation; }), Promise.resolve().then(function () { return dropdown$1; }), Promise.resolve().then(function () { return reveal$1; }), Promise.resolve().then(function () { return wishlist$1; }), Promise.resolve().then(function () { return countrySelectorModal$1; }), Promise.resolve().then(function () { return eventForm$1; }), Promise.resolve().then(function () { return componentBisForm$1; }), Promise.resolve().then(function () { return localizationForm$1; }), Promise.resolve().then(function () { return handleNewsletterEvent; }), Promise.resolve().then(function () { return componentCarousel$1; }), Promise.resolve().then(function () { return componentModal$1; }), Promise.resolve().then(function () { return componentProductCard$1; }), Promise.resolve().then(function () { return componentProductForm$1; }), Promise.resolve().then(function () { return componentDrawer$1; }), Promise.resolve().then(function () { return componentNewsletterSignup$1; }), Promise.resolve().then(function () { return componentAccordion$1; }), Promise.resolve().then(function () { return componentTabs$1; }), Promise.resolve().then(function () { return componentAddToWishlist$1; }), Promise.resolve().then(function () { return componentSnackbar$1; }), Promise.resolve().then(function () { return componentQuickAdd$1; }), Promise.resolve().then(function () { return componentCartNotification$1; }), Promise.resolve().then(function () { return componentSeeMore$1; }), Promise.resolve().then(function () { return themeSearchOverlay$1; }), Promise.resolve().then(function () { return wishlistCounter$1; }), Promise.resolve().then(function () { return wishlistGrid$1; }), Promise.resolve().then(function () { return wishlistStateBlock$1; }), Promise.resolve().then(function () { return fragmentCursor$1; }), Promise.resolve().then(function () { return fragmentOptionSelect$1; }), Promise.resolve().then(function () { return fragmentSearchTrigger$1; }), Promise.resolve().then(function () { return fragmentSubMenu$1; }), Promise.resolve().then(function () { return fragmentVideo$1; }), Promise.resolve().then(function () { return sectionAnnouncementBar$1; }), Promise.resolve().then(function () { return sectionArticleTeaser$1; }), Promise.resolve().then(function () { return sectionHeader$1; }), Promise.resolve().then(function () { return sectionCountdownTeaser$1; }), Promise.resolve().then(function () { return sectionProductRecommendations$1; }), Promise.resolve().then(function () { return sectionWishlistSlider$1; }), Promise.resolve().then(function () { return componentSapDownloadRedirection$1; })];
        const componentsObj = hydrateComponents(components, setScrollbarWidth);
        await componentsObj.hydrate?.();
      })();
    });

    const camelCase = s => s.replace(/-./g, x => x[1].toUpperCase());
    const capitalize = s => s.charAt(0).toUpperCase() + s.slice(1);
    function groupByRef(element, result, onlyFirst = false) {
      const ref = element.getAttribute('data-ref');
      if (!ref) return;
      const refs = ref.split(' ').map(camelCase);
      refs.forEach(capitalizedRef => {
        if (onlyFirst) {
          if (!result[capitalizedRef]) {
            result[capitalizedRef] = element;
          }
        } else {
          if (result[capitalizedRef]) {
            if (Array.isArray(result[capitalizedRef])) {
              result[capitalizedRef].push(element);
            } else {
              result[capitalizedRef] = [result[capitalizedRef], element];
            }
          } else {
            result[capitalizedRef] = element;
          }
        }
      });
    }
    const getElementsByRef$b = (refs, target) => {
      const root = target instanceof HTMLElement ? target : document.body;
      const result = {};
      const selector = Array.isArray(refs) ? refs.map(ref => `[data-ref*="${ref}"]`).join(',') : `[data-ref*="${refs}"]`;
      const elements = root.querySelectorAll(selector);
      elements.forEach(element => groupByRef(element, result));
      return result;
    };
    const getRefs$9 = (target = document.body, watch) => {
      const root = typeof target === 'string' ? document.querySelector(`[data-namespace="${target}"]`) : target;
      if (!root) {
        return;
      }
      const name = root?.getAttribute('data-namespace');
      return watch ? _watched(root, name, watch) : _refs(root, name, true);
    };
    function _refs(root, name, includeRoot) {
      const attribute = name ? `data-ref-${name}` : 'data-ref';
      return [...root.querySelectorAll(`[${attribute}]`)].reduce((refs, el) => {
        const dataset = name ? `ref${capitalize(name)}` : 'ref';
        return {
          ...(includeRoot && {
            root
          }),
          ...refs,
          ...(camelCase(el.dataset[dataset]) || 'item').split(' ').reduce((acc, newRef) => ({
            ...acc,
            [newRef]: refs[newRef] ? [refs[newRef], el].flat() : el
          }), {})
        };
      }, {});
    }
    function _watched(r, n, onChange) {
      const observer = new MutationObserver(() => {
        ref.current = _refs(r, n);
        if (typeof onChange === 'function') onChange();
      });
      observer.observe(r, {
        childList: true,
        subtree: true
      });
      const ref = {
        root: r,
        current: _refs(r, n),
        unwatch: observer.disconnect.bind(observer)
      };
      return ref;
    }
    getRefs$9();

    var imageLoaded = () => {
      const {
        image,
        video
      } = getElementsByRef$b(['image', 'video']);
      const images = image ? Array.isArray(image) ? image : [image] : [];
      const videos = video ? Array.isArray(video) ? video : [video] : [];
      const handleImageLoad = ({
        target
      }) => {
        target.classList.add('loaded');
      };
      images.forEach(image => {
        if (image.complete) {
          handleImageLoad({
            target: image
          });
        } else {
          image.addEventListener('load', handleImageLoad, {
            once: true
          });
        }
      });
      videos.forEach(video => {
        video.addEventListener('canplaythrough', handleImageLoad);
        setTimeout(() => {
          handleImageLoad({
            target: video
          });
        }, 1000);
      });
    };

    var imageLoaded$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: imageLoaded
    });

    const breakpoints$3 = {
      'sm': 600,
      'md': 1024,
      'lg': 1200,
      'xl': 1440,
      'page-max': 1660
    };

    const progress = (() => {
      const multiplier = 0.1;
      let instances = [];
      window.ins = instances;
      let ticking = false;
      let raf = null;
      const start = () => {
        ticking = true;
        animate();
      };
      const pause = () => {
        ticking = false;
        if (raf) cancelAnimationFrame(raf);
      };
      const destroy = () => {
        pause();
        instances = [];
      };
      const isAnimating = () => {
        return ticking;
      };
      const add = ({
        element,
        value
      }) => {
        const valueAsFloat = value;
        const bounds = element.getBoundingClientRect();
        const startFromZero = bounds.y + bounds.height + scrollY >= 0 && bounds.y + scrollY < innerHeight ? true : false;
        const initialProgressInScreen = Math.max((innerHeight - bounds.y - scrollY) / (innerHeight + bounds.height), 0);
        let startValue = 0;
        let endValue = 0;
        if (startFromZero) {
          startValue = 0;
        } else {
          startValue = valueAsFloat * -0.5;
        }
        endValue = valueAsFloat * 0.5;
        const instance = {
          element,
          startValue,
          endValue,
          range: endValue - startValue,
          currentValue: null,
          initialProgressInScreen,
          isInitialized: false
        };
        instances.push(instance);
        if (!ticking) {
          start();
        }
      };
      const animate = () => {
        const {
          innerHeight
        } = window;
        let instancesLength = instances.length;
        let i = instancesLength;
        if (raf) {
          cancelAnimationFrame(raf);
        }
        if (ticking) {
          raf = requestAnimationFrame(animate);
        }
        while (i) {
          i--;
          const instance = instances[i];
          const {
            element,
            startValue,
            endValue,
            initialProgressInScreen,
            isInitialized
          } = instance;
          const bounds = element.getBoundingClientRect();
          let progress = (innerHeight - bounds.y) / (innerHeight + bounds.height);
          let normalizedProgress = (progress - initialProgressInScreen) / (1 - initialProgressInScreen);
          if (normalizedProgress > 1) normalizedProgress = 1;
          if (normalizedProgress < 0) normalizedProgress = 0;
          if (normalizedProgress === 0 && instance.currentValue === startValue) continue;
          if (normalizedProgress >= 1 && instance.currentValue === endValue) continue;
          const targetValue = (endValue - startValue) * normalizedProgress + startValue;
          const delta = targetValue - (instance.currentValue ?? 0);
          const velocity = Math.abs(delta) < 0.1 ? 0 : delta * multiplier;
          instance.currentValue = (instance.currentValue ?? 0) + velocity;
          instance.currentValue = parseFloat(instance.currentValue.toFixed(3));
          if (Math.abs(delta) < 0.1 || !isInitialized) {
            instance.currentValue = parseFloat(targetValue.toFixed(3));
            instance.isInitialized = true;
          }
          const transformString = `translate3d(0, ${instance.currentValue}px,0)`;
          setTransform(element, transformString);
        }
      };
      const setTransform = (element, transform) => {
        element.style.transform = transform;
      };
      return {
        start,
        pause,
        destroy,
        isAnimating,
        add
      };
    })();

    var parallax = () => {
      const ref = getElementsByRef$b(['parallax-el']);
      if (!ref?.parallaxEl) return;
      const parallaxItems = Array.isArray(ref.parallaxEl) ? ref.parallaxEl : [ref.parallaxEl];
      let items = [];
      let isMobile = window.innerWidth < breakpoints$3.md;
      const init = () => {
        window.addEventListener('load', isReady);
      };
      const isReady = () => {
        items = isMobile ? parallaxItems.filter(item => !item.hasAttribute('data-disable-mobile-parallax')) : parallaxItems;
        items.forEach(item => {
          progress.add({
            element: item,
            value: item.dataset.parallax ? parseFloat(item.dataset.parallax) : 0
          });
        });
      };
      init();
      return () => {
        window.removeEventListener('load', isReady);
        progress.destroy();
      };
    };

    var parallax$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: parallax
    });

    function initKeyboardNavigation() {
      const handleMouseDown = () => {
        document.body.classList.remove('keyboard-navigation');
      };
      const handleKeyDown = e => {
        if (e.key === 'Tab') {
          document.body.classList.add('keyboard-navigation');
        }
      };
      document.addEventListener('mousedown', handleMouseDown);
      document.addEventListener('keydown', handleKeyDown);
      return () => {
        document.removeEventListener('mousedown', handleMouseDown);
        document.removeEventListener('keydown', handleKeyDown);
      };
    }
    document.addEventListener('DOMContentLoaded', initKeyboardNavigation);

    var keyboardNavigation = /*#__PURE__*/Object.freeze({
        __proto__: null,
        initKeyboardNavigation: initKeyboardNavigation
    });

    const {
      getRefs: getRefs$8,
      getElementsByRef: getElementsByRef$a
    } = window.PoleneLibs.Refs;
    const initDropdown = dropdown => {
      const ref = getRefs$8(dropdown);
      const KEYS = {
        SPACEBAR: [0, 32],
        ENTER: 13,
        DOWN_ARROW: 40,
        UP_ARROW: 38,
        ESCAPE: 27
      };
      if (!ref.items) return;
      if (dropdown.dataset.dropdown === 'store-selector') {
        const currentStore = ref.items.find(item => {
          const link = item.querySelector('a');
          return link?.href?.includes(location.hostname);
        });
        if (currentStore) {
          ref.selected.textContent = currentStore.textContent;
        }
      }
      ref.selected.addEventListener('click', e => toggleVisibility(e));
      ref.selected.addEventListener('keydown', e => toggleVisibility(e));
      document.body.addEventListener('click', e => handleBodyClick(e));
      const handleBodyClick = e => {
        const clickOutsideDropdown = !e.target.closest('[data-ref="dropdown"]');
        if (clickOutsideDropdown) close();
      };
      const handleClose = e => {
        setSelected(e);
        close();
      };
      const handleKeypress = e => {
        switch (e.keyCode) {
          case KEYS.ENTER:
            handleClose(e);
            return;
          case KEYS.DOWN_ARROW:
            focusNextItem(KEYS.DOWN_ARROW);
            return;
          case KEYS.UP_ARROW:
            focusNextItem(KEYS.UP_ARROW);
            return;
          case KEYS.ESCAPE:
            close();
            return;
          default:
            return;
        }
      };
      const itemTeardowns = ref.items.map(item => {
        item.addEventListener('click', handleClose);
        item.addEventListener('keydown', handleKeypress);
        return () => {
          item.removeEventListener('click', handleClose);
          item.removeEventListener('keydown', handleKeypress);
        };
      });
      function setSelected(e) {
        ref.selected.textContent = e.target.innerText;
      }
      function close() {
        ref.list.classList.remove('open');
        ref.container.setAttribute('aria-expanded', false);
        ref.container.hidden = true;
        ref.root.focus();
      }
      function toggleVisibility(e) {
        let openDropDown = KEYS.SPACEBAR.includes(e.keyCode) || e.keyCode === KEYS.ENTER;
        if (e.keyCode === KEYS.ESCAPE) close();
        if (e.type === 'click' || openDropDown) {
          ref.list.classList.toggle('open');
          ref.container.setAttribute('aria-expanded', ref.list.classList.contains('open'));
          ref.container.hidden = false;
        }
        if (e.keyCode === KEYS.DOWN_ARROW) {
          focusNextItem(KEYS.DOWN_ARROW);
        }
        if (e.keyCode === KEYS.UP_ARROW) {
          focusNextItem(KEYS.UP_ARROW);
        }
      }
      function focusNextItem(direction) {
        if (!ref.list.classList.contains('open')) {
          return;
        }
        const activeElement = document.activeElement;
        const activeElementId = activeElement instanceof HTMLElement ? activeElement.dataset?.id : undefined;
        if (activeElementId === 'selected') {
          ref.items[0].focus();
          return;
        }
        const activeItem = ref.items.findIndex(item => item.dataset.id === activeElementId);
        if (direction === KEYS.DOWN_ARROW) {
          const isLastItem = activeItem < ref.items.length - 1;
          if (isLastItem) {
            const nextListItemId = ref.items[activeItem + 1].dataset.id;
            ref.items.find(item => item.dataset.id === nextListItemId).focus();
          }
        }
        if (direction === KEYS.UP_ARROW) {
          const isFirstItem = activeItem > 0;
          if (isFirstItem) {
            const nextListItemId = ref.items[activeItem - 1].dataset.id;
            ref.items.find(item => item.dataset.id === nextListItemId).focus();
          }
        }
      }
      return () => {
        itemTeardowns.forEach(teardown => teardown());
      };
    };
    var dropdown = () => {
      const {
        dropdown
      } = getElementsByRef$a(['dropdown']);
      if (!dropdown) return;
      const elements = Array.isArray(dropdown) ? dropdown : [dropdown];
      const instances = elements.map(initDropdown);
      return () => {
        instances.forEach(teardown => teardown?.());
      };
    };

    var dropdown$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: dropdown
    });

    var reveal = () => {
      const {
        getElementsByRef
      } = window.PoleneLibs.Refs;
      const {
        revealElement
      } = getElementsByRef('reveal-element');
      if (!revealElement) return;
      const items = Array.isArray(revealElement) ? Array.from(revealElement) : [revealElement];
      const init = () => {
        items.forEach(item => item.classList.add('is-revealed'));
      };
      init();
    };

    var reveal$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: reveal
    });

    const cleanPath = path => path.replace(/\/+/g, '/');
    const cleanPaths = paths => {
      return Object.fromEntries(Object.entries(paths).map(([key, path]) => [key, cleanPath(path)]));
    };
    const ROOT_PATH = window?.Shopify?.routes?.root || '/';
    const PROXY_BASE_PATH = cleanPath(`${ROOT_PATH}/apps/polene-theme-features`);
    const KLAVIYO_BASE_PATH = 'https://a.klaviyo.com/client';
    cleanPaths({
      WISHLIST: `${ROOT_PATH}/pages/wishlist`,
      ACCOUNT: `${ROOT_PATH}/account`,
      LOGIN: `${ROOT_PATH}/account/login`,
      LOGIN_MULTI_PASS: `${ROOT_PATH}/account/login/multipass`
    });
    const API_PROXY = {
      RETURNS: PROXY_BASE_PATH + '/order-returns',
      RETURN_BUTTON: PROXY_BASE_PATH + '/order-return-button',
      ORDER_HISTORY: PROXY_BASE_PATH + '/order-history',
      ORDER_INVOICE: PROXY_BASE_PATH + '/order-invoice',
      ORDER_CREDIT_NOTE: PROXY_BASE_PATH + '/order-credit-note',
      ORDER_DETAILS: PROXY_BASE_PATH + '/order-details',
      ORDER_DETAILS_SAP: PROXY_BASE_PATH + '/order-details-sap',
      DELETE_ACCOUNT: PROXY_BASE_PATH + '/delete-account',
      CREATE_CUSTOMER: PROXY_BASE_PATH + '/customer-create',
      UPDATE_CUSTOMER: PROXY_BASE_PATH + '/customer-update',
      CUSTOMER_SMS_CONSENT: PROXY_BASE_PATH + '/customer-sms-marketing',
      CUSTOMER_WISHLIST: PROXY_BASE_PATH + '/customer-wishlist',
      STOREFRONT: PROXY_BASE_PATH + '/storefront',
      MARKETING_SUBSCRIBE: PROXY_BASE_PATH + '/marketing-subscribe',
      BACK_IN_STOCK_SUBSCRIBE: PROXY_BASE_PATH + '/back-in-stock-subscribe',
      WISHLIST: PROXY_BASE_PATH + '/wishlist'
    };
    const KLAVIYO_ID = window.P1?.klaviyo?.public_key;
    window.P1?.klaviyo?.list_id;
    const API_KLAVIYO = {
      HEADERS: {
        'revision': '2025-01-15',
        'content-type': 'application/vnd.api+json'
      },
      BACK_IN_STOCK_SUB: KLAVIYO_BASE_PATH + `/back-in-stock-subscriptions/?company_id=${KLAVIYO_ID}`,
      SUBSCRIPTION: KLAVIYO_BASE_PATH + `/subscriptions?company_id=${KLAVIYO_ID}`,
      EVENT: KLAVIYO_BASE_PATH + `/profiles?company_id=${KLAVIYO_ID}`
    };
    const FOCUSABLE_SELECTORS = ['button', '[href]', 'input', 'select', 'textarea', '[tabindex]:not([tabindex="-1"])'].join(', ');
    const TIMEOUTS = {
      DELAY_50: 50,
      DELAY_150: 150,
      COMMON_DELAY_300: 300,
      DELAY_500: 500,
      DELAY_600: 600,
      DELAY_4000: 4000
    };

    var WishlistEvent;
    (function (WishlistEvent) {
      WishlistEvent[WishlistEvent["UPDATE"] = 0] = "UPDATE";
      WishlistEvent[WishlistEvent["ADD"] = 1] = "ADD";
      WishlistEvent[WishlistEvent["REMOVE"] = 2] = "REMOVE";
    })(WishlistEvent || (WishlistEvent = {}));

    class Wishlist {
      static CACHE_EXPIRATION_AGE = 0;
      static productIds = [];
      static initialized = false;
      static localId = undefined;
      static eventHandlers = {
        [WishlistEvent.UPDATE]: [],
        [WishlistEvent.ADD]: [],
        [WishlistEvent.REMOVE]: []
      };
      static async init() {
        if (this.initialized) return;
        this.authenticate();
        if (this.localId) {
          this.setupEndpoint();
          if (!this.loadFromCache()) await this.get();
          this.callback(WishlistEvent.UPDATE);
        }
        this.initialized = true;
      }
      static cache = () => {
        localStorage.setItem('wishlist_products', JSON.stringify(Array.isArray(this.productIds) ? this.productIds : []));
        localStorage.setItem('wishlist_products_timestamp', Date.now().toString());
      };
      static authenticate = () => {
        const localId = localStorage.getItem('local_id');
        if (localId) this.localId = localId;else if (window.location.href.includes('wishlist')) this.registerLocally();
      };
      static registerLocally = () => {
        this.localId = self.crypto.randomUUID();
        localStorage.setItem('local_id', this.localId);
        this.setupEndpoint();
      };
      static setupEndpoint = () => {
        this.endpoint = `${API_PROXY.WISHLIST}?local_id=${this.localId}`;
      };
      static loadFromCache() {
        const cached = localStorage.getItem('wishlist_products');
        const timestamp = localStorage.getItem('wishlist_products_timestamp');
        if (cached && timestamp) {
          const age = Date.now() - parseInt(timestamp);
          this.productIds = JSON.parse(cached);
          if (age < this.CACHE_EXPIRATION_AGE) return true;
        }
        return false;
      }
      static callback = event => {
        const ids = [...this.productIds];
        if (Array.isArray(event)) {
          event.forEach(e => this.eventHandlers[e].forEach(func => func(ids)));
        } else this.eventHandlers[event].forEach(func => func(ids));
      };
      static async request(endpoint, options = {}) {
        try {
          const response = await fetch(endpoint, options);
          if (!response.ok) {
            throw new Error(`HTTP ${response.status}: ${response.statusText}`);
          }
          const data = await response.json();
          return {
            data
          };
        } catch (error) {
          const message = error instanceof Error ? error.message : 'Unknown error';
          return {
            error: message
          };
        }
      }
      static getHTML = async (type = 'grid') => {
        try {
          const response = await fetch(`${this.endpoint}&type=${type}`, {
            headers: {
              Accept: 'text/html'
            }
          });
          if (!response.ok) {
            throw new Error(`HTTP ${response.status}: ${response.statusText}`);
          }
          const data = await response.text();
          return data;
        } catch (error) {
          error instanceof Error ? error.message : 'Unknown error';
          return '';
        }
      };
      static get = async () => {
        if (!this.localId) this.registerLocally();
        const result = await this.request(this.endpoint);
        if (result.data) {
          this.productIds = result.data.products;
          this.cache();
        }
        return this.productIds;
      };
      static add = async productId => {
        if (!this.localId) this.registerLocally();
        if (this.productIds.includes(productId)) return true;
        const formData = new FormData();
        formData.append('product_id', productId);
        const result = await this.request(`${this.endpoint}`, {
          method: 'POST',
          body: formData
        });
        if (result.data?.success) {
          this.productIds.push(productId);
          this.cache();
          this.callback([WishlistEvent.ADD, WishlistEvent.UPDATE]);
          return true;
        }
        return false;
      };
      static remove = async productId => {
        if (!this.localId) return false;
        if (!this.productIds.includes(productId)) return true;
        const formData = new FormData();
        formData.append('product_id', productId);
        const result = await this.request(this.endpoint, {
          method: 'DELETE',
          body: formData
        });
        if (result.data?.success) {
          this.productIds = this.productIds.filter(id => id !== productId);
          this.cache();
          this.callback([WishlistEvent.REMOVE, WishlistEvent.UPDATE]);
          return true;
        }
        return false;
      };
      static count = () => this.productIds.length;
      static isInWishlist = productId => {
        return this.productIds.includes(productId);
      };
      static getProductIds = () => {
        return [...this.productIds];
      };
      static setEventListeners = (event, callback) => this.eventHandlers[event].push(callback);
      static removeEventListeners = (event, callback) => this.eventHandlers[event] = this.eventHandlers[event].filter(func => func !== callback);
    }
    var wishlist = async () => await Wishlist.init();

    var wishlist$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        Wishlist: Wishlist,
        default: wishlist
    });

    class FocusTrap {
      focusableElements = [];
      previousActiveElement = null;
      constructor(container) {
        this.container = container;
        this.boundHandleKeydown = this.handleKeydown.bind(this);
      }
      activate() {
        this.previousActiveElement = document.activeElement;
        this.focusableElements = this.getFocusableElements();
        document.addEventListener('keydown', this.boundHandleKeydown);
        if (this.focusableElements.length > 0) {
          this.focusableElements[0].focus();
        } else {
          this.container.focus();
        }
      }
      deactivate() {
        document.removeEventListener('keydown', this.boundHandleKeydown);
        if (this.previousActiveElement) {
          this.previousActiveElement.focus();
        }
      }
      handleKeydown(event) {
        if (!this.focusableElements.length) return;
        const firstElement = this.focusableElements[0];
        const lastElement = this.focusableElements[this.focusableElements.length - 1];
        const activeElement = document.activeElement;
        if (event.key === 'Tab') {
          if (!event.shiftKey && activeElement === lastElement) {
            firstElement.focus();
            event.preventDefault();
          } else if (event.shiftKey && activeElement === firstElement) {
            lastElement.focus();
            event.preventDefault();
          }
        }
      }
      getFocusableElements() {
        const elements = Array.from(this.container.querySelectorAll(FOCUSABLE_SELECTORS));
        return elements.filter(element => {
          return !element.hasAttribute('disabled') && element.offsetParent !== null && !element.hasAttribute('aria-hidden') && !element.hasAttribute('hidden');
        });
      }
    }

    const SEARCH_PARAM = 'openCountrySelector';
    const CLOSE_BUTTON_SELECTOR = '.country-selector__popup__header__close';
    class CountrySelectorModal {
      focusTrap = null;
      constructor() {
        this.selectorModals = document.querySelectorAll('.selector_popup');
        this.selectorButtons = document.querySelectorAll('.selector-button');
        this.boundHandleEscapeKeydown = this.handleEscapeKeydown.bind(this);
        this.boundHandleButtonClick = this.handleButtonClick.bind(this);
        this.boundCloseModal = this.closeModal.bind(this);
      }
      handleButtonClick(event) {
        const button = event.currentTarget;
        const countrySelectorModal = document.querySelector(`#${button.dataset.puid}`);
        if (countrySelectorModal && !document.body.classList.contains('search-open')) {
          this.showModal(countrySelectorModal);
        }
      }
      showModal(countrySelectorModal) {
        if (!countrySelectorModal) return;
        const closeModalButton = countrySelectorModal.querySelector(CLOSE_BUTTON_SELECTOR);
        if (closeModalButton) {
          closeModalButton.addEventListener('click', this.boundCloseModal);
        }
        document.addEventListener('keydown', this.boundHandleEscapeKeydown);
        countrySelectorModal.classList.add('is-open');
        document.querySelector('body')?.classList.add('country-selector-modal-is-open');
        countrySelectorModal.setAttribute('tabindex', '0');
        this.focusTrap = new FocusTrap(countrySelectorModal);
        this.focusTrap.activate();
      }
      closeModal() {
        const countrySelectorModal = document.querySelector('.selector_popup.is-open');
        if (countrySelectorModal) {
          countrySelectorModal.classList.remove('is-open');
          document.querySelector('body')?.classList.remove('country-selector-modal-is-open');
          this.clearEvents(countrySelectorModal);
          const url = new URL(window.location.href);
          const urlParams = new URLSearchParams(url.search);
          urlParams.delete(SEARCH_PARAM);
          url.search = urlParams.toString();
          window.history.replaceState({}, document.title, url.toString());
        }
      }
      clearEvents(countrySelectorModal) {
        const modalCloseButton = countrySelectorModal.querySelector(CLOSE_BUTTON_SELECTOR);
        document.removeEventListener('keydown', this.boundHandleEscapeKeydown);
        this.focusTrap?.deactivate();
        if (modalCloseButton) {
          modalCloseButton.removeEventListener('click', this.boundCloseModal);
        }
      }
      handleEscapeKeydown(event) {
        if (event.key === 'Escape') {
          this.closeModal();
        }
      }
      getSearchParam() {
        const url = new URL(window.location.href);
        const urlParams = new URLSearchParams(url.search);
        urlParams.delete('country');
        url.search = urlParams.toString();
        window.history.replaceState({}, document.title, url.toString());
        return urlParams.has(SEARCH_PARAM);
      }
      setupEventListeners() {
        if (!this.selectorModals || this.selectorButtons.length === 0) return;
        this.selectorButtons.forEach(button => {
          button.addEventListener('click', this.boundHandleButtonClick);
        });
      }
      cleanup() {
        if (this.selectorButtons) {
          this.selectorButtons.forEach(button => {
            button.removeEventListener('click', this.boundHandleButtonClick);
          });
        }
        document.removeEventListener('keydown', this.boundHandleEscapeKeydown);
        if (this.selectorModals) {
          this.selectorModals.forEach(modal => {
            if (modal.classList.contains('is-open')) {
              this.clearEvents(modal);
              modal.classList.remove('is-open');
            }
          });
        }
        document.querySelector('body')?.classList.remove('country-selector-modal-is-open');
      }
      init() {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => {
            this.setupEventListeners();
          });
        } else {
          this.setupEventListeners();
        }
        if (this.getSearchParam()) {
          const defaultModal = this.selectorModals[0];
          if (defaultModal) {
            this.showModal(defaultModal);
          }
        }
        return this.cleanup.bind(this);
      }
    }
    var countrySelectorModal = () => {
      const modal = new CountrySelectorModal();
      return modal.init();
    };

    var countrySelectorModal$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        CountrySelectorModal: CountrySelectorModal,
        default: countrySelectorModal
    });

    var InputFields;
    (function (InputFields) {
      InputFields["FirstName"] = "firstName";
      InputFields["LastName"] = "lastName";
      InputFields["Address1"] = "address1";
      InputFields["Address2"] = "address2";
      InputFields["Zip"] = "zip";
      InputFields["City"] = "city";
      InputFields["Phone"] = "phone";
      InputFields["Birthdate"] = "birthdate";
      InputFields["email"] = "email";
      InputFields["password"] = "password";
      InputFields["confirmPassword"] = "confirmPassword";
      InputFields["civility"] = "civility";
    })(InputFields || (InputFields = {}));
    const FormSelectors = {
      Customer: {
        BIRTHDATE: 'input[name=birthdate]',
        PHONE: 'input[name="phone"]',
        PHONE_COUNTRY_SELECT: 'select[name="phone_country_select"]',
        SUBMIT_BUTTON: 'button[type="submit"]',
        FIRST_NAME: 'input[name="firstName"]',
        LAST_NAME: 'input[name="lastName"]',
        EMAIL: 'input[name="email"]',
        PASSWORD: 'input[name="password"]',
        CIVILITY: 'select[name="civility"]',
        Shopify: {
          Selectors: {
            EMAIL: 'input[name="customer[email]"]',
            PASSWORD: 'input[name="customer[password]"]',
            CONFIRM_PASSWORD: 'input[name="customer[password_confirmation]"]'
          }
        },
        RecoverPassword: {
          EMAIL: 'input[name="email"]'
        },
        Update: {
          ID: '#profile_form',
          FORM: '#update_customer_form',
          Selectors: {
            FIRST_NAME: 'input[name="firstName"]',
            LAST_NAME: 'input[name="lastName"]',
            PHONE: 'input[name="phone"]'
          },
          Fields: {
            FirstName: 'firstName',
            LastName: 'lastName',
            Phone: 'phone'
          }
        },
        Address: {
          COUNTRY_SELECT: 'select[name="address[country]"]',
          PHONE: 'input[name="address[phone]"]',
          FIRST_NAME: 'input[name="address[first_name]"]',
          LAST_NAME: 'input[name="address[last_name]"]',
          ADDRESS_1: 'input[name="address[address1]"]',
          ADDRESS_2: 'input[name="address[address2]"]',
          ZIP: 'input[name="address[zip]"]',
          CITY: 'input[name="address[city]"]'
        }
      }
    };
    const defaultNoValidationConf = {
      noSpecialChar: undefined,
      nonLatinCharacters: undefined,
      noNumber: undefined,
      maxLength: undefined,
      minLength: 0,
      required: false
    };
    const inputTextDefaultValidationConf = {
      nonLatinCharacters: true,
      noSpecialChar: true,
      noNumber: true,
      maxLength: 35,
      minLength: 0,
      required: true
    };
    const FormValidations = {
      [InputFields.FirstName]: {
        ...inputTextDefaultValidationConf,
        minLength: 2,
        maxLength: 35
      },
      [InputFields.LastName]: {
        ...inputTextDefaultValidationConf,
        minLength: 2,
        maxLength: 35
      },
      [InputFields.Address1]: {
        ...inputTextDefaultValidationConf,
        noNumber: false,
        required: true
      },
      [InputFields.Address2]: {
        ...inputTextDefaultValidationConf,
        noNumber: false,
        required: false
      },
      [InputFields.City]: {
        ...inputTextDefaultValidationConf,
        noNumber: false,
        maxLength: undefined,
        required: true
      },
      [InputFields.Zip]: {
        ...inputTextDefaultValidationConf,
        noNumber: false,
        maxLength: 10,
        required: true
      },
      [InputFields.Phone]: {
        ...defaultNoValidationConf
      },
      [InputFields.email]: {
        ...defaultNoValidationConf,
        required: true
      },
      [InputFields.password]: {
        ...inputTextDefaultValidationConf,
        noNumber: false,
        noSpecialChar: false,
        minLength: 5
      },
      [InputFields.confirmPassword]: {
        ...inputTextDefaultValidationConf,
        noNumber: false,
        noSpecialChar: false,
        minLength: 5
      },
      [InputFields.civility]: {
        ...defaultNoValidationConf,
        required: true
      },
      [InputFields.Birthdate]: {
        ...inputTextDefaultValidationConf,
        nonLatinCharacters: false,
        noSpecialChar: false,
        maxDate: Date.now(),
        required: false,
        noNumber: false
      }
    };

    var ErrorTypes;
    (function (ErrorTypes) {
      ErrorTypes["invalidTitle"] = "invalid_title";
      ErrorTypes["invalidName"] = "invalid_name";
      ErrorTypes["invalidCivility"] = "invalid_civility";
      ErrorTypes["nonLatinCharacters"] = "contains_non_latin_characters";
      ErrorTypes["maxLengthExceeded"] = "max_length_exceeded";
      ErrorTypes["minLength"] = "min_length";
      ErrorTypes["containsNumbers"] = "contains_numbers";
      ErrorTypes["containsSpecialChars"] = "contains_special_chars";
      ErrorTypes["empty"] = "empty";
      ErrorTypes["phoneNumberInvalid"] = "phone_number_invalid";
      ErrorTypes["formSubmitError"] = "form_error";
      ErrorTypes["TAKEN"] = "email_taken";
      ErrorTypes["maxDate"] = "max_date";
      ErrorTypes["invalidDate"] = "invalid_date";
    })(ErrorTypes || (ErrorTypes = {}));

    const containsNonLatinCharactersFieldError = str => {
      const nonLatinRegex = /[^\u0000-\u017F]+/;
      return nonLatinRegex.test(str || '');
    };
    const validateNotContainsNonLatinCharacters = str => {
      if (containsNonLatinCharactersFieldError(str)) {
        return {
          isValid: false,
          error: ErrorTypes.nonLatinCharacters
        };
      }
      return {
        isValid: true
      };
    };
    function validateMaxLength(str, maxLength) {
      if (str.length > maxLength) {
        return {
          isValid: false,
          error: ErrorTypes.maxLengthExceeded
        };
      }
      return {
        isValid: true
      };
    }
    function validateMinLength(str, minLength) {
      if (str.length < minLength) {
        return {
          isValid: false,
          error: ErrorTypes.minLength
        };
      }
      return {
        isValid: true
      };
    }
    function validateNoNumbers(str) {
      const numberRegex = /\d/;
      if (numberRegex.test(str)) {
        return {
          isValid: false,
          error: ErrorTypes.containsNumbers
        };
      }
      return {
        isValid: true
      };
    }
    function validateNoSpecialChars(str) {
      const specialCharsRegex = /[%_;|]/;
      if (specialCharsRegex.test(str)) {
        return {
          isValid: false,
          error: ErrorTypes.containsSpecialChars
        };
      }
      return {
        isValid: true
      };
    }
    function validateNotEmpty(str) {
      const withoutWhiteSpace = str.replace(/\s/g, '');
      if (withoutWhiteSpace.length <= 0) return {
        isValid: false,
        error: ErrorTypes.empty
      };
      return {
        isValid: true
      };
    }
    function validateMaxDate(inputTimestamp, limitTimestamp) {
      if (inputTimestamp > limitTimestamp) {
        return {
          isValid: false,
          error: ErrorTypes.maxDate
        };
      }
      return {
        isValid: true
      };
    }
    function validateDate(ts) {
      return !ts ? {
        isValid: false,
        error: ErrorTypes.invalidDate
      } : {
        isValid: true
      };
    }

    const DateFormat = window.PoleneLibs.DateFormat;
    class InputValidation {
      inputs = {};
      dateFormat = new DateFormat();
      hasSubmitOnce = false;
      constructor({
        formContainer,
        inputs
      }) {
        this.formContainer = formContainer;
        this.inputs = inputs;
        this.form = this.formContainer.querySelector('form');
        if (!this.form) throw new Error('Form not found');
        this.submitButton = this.form.querySelector(FormSelectors.Customer.SUBMIT_BUTTON);
        if (!this.submitButton) throw new Error('Submit Button not found');
      }
      triggerValidationEffect(input, validation) {
        if (!validation.isValid && validation.error) {
          this.displayErrorSpan(input, validation.error, validation.message);
          if (this.submitButton) this.submitButton.disabled = true;
          return false;
        }
        this.removeErrorSpan(input);
        if (this.submitButton) this.submitButton.disabled = false;
        return true;
      }
      displayErrorSpan(input, error, message) {
        this.removeErrorSpan(input);
        const errorSpan = this.form?.querySelector(`span[data-ref=${input.id}-${error}]`);
        if (!errorSpan) return;
        if (message) errorSpan.textContent = message;
        input.ariaInvalid = 'true';
        input.setAttribute('aria-describedby', `${input.id}-${error}`);
        errorSpan.hidden = false;
        errorSpan.style.display = 'block';
      }
      removeErrorSpan(input) {
        const errorSpans = this.form?.querySelectorAll(`span[data-ref^=${input.id}]`);
        if (!errorSpans) return;
        input.ariaInvalid = 'false';
        input.removeAttribute('aria-describedby');
        errorSpans.forEach(span => {
          span.hidden = true;
          span.style.display = 'none';
        });
      }
      checkRequiredInput({
        input
      }) {
        if (!input) return true;
        let inputIsEmpty = false;
        if (!input.validationConfig.required) return;
        const emptyCheck = validateNotEmpty(input.selector.value);
        if (!this.triggerValidationEffect(input.selector, emptyCheck)) return false;
        inputIsEmpty = true;
        return inputIsEmpty;
      }
      checkRequiredInputs({
        inputs
      }) {
        if (!inputs) return false;
        let isValid = true;
        Object.values(this.inputs).forEach(input => {
          if (!input.validationConfig.required) return;
          const emptyCheck = validateNotEmpty(input.selector.value);
          if (!this.triggerValidationEffect(input.selector, emptyCheck)) {
            isValid = false;
          }
        });
        return isValid;
      }
      validateInput(input) {
        if (this.hasSubmitOnce) {
          const empty = validateNotEmpty(input.selector.value);
          if (!this.triggerValidationEffect(input.selector, empty)) {
            return false;
          }
        }
        if (input.selector.dataset.ref == 'input-date' && input.selector.value != `${this.dateFormat.placeholder}  (${input.selector.dataset.tOptional})`) {
          const date = this.dateFormat.parse(input.selector.value);
          const invalidDateCheck = validateDate(date);
          if (!this.triggerValidationEffect(input.selector, invalidDateCheck)) return false;
          if (input.validationConfig.maxDate) {
            const maxDateCheck = validateMaxDate(date ?? NaN, input.validationConfig.maxDate);
            if (!this.triggerValidationEffect(input.selector, maxDateCheck)) return false;
          }
        }
        if (input.validationConfig.noSpecialChar) {
          const speCharCheck = validateNoSpecialChars(input.selector.value);
          if (!this.triggerValidationEffect(input.selector, speCharCheck)) {
            return false;
          }
        }
        if (input.validationConfig.noNumber) {
          const noNumb = validateNoNumbers(input.selector.value);
          if (!this.triggerValidationEffect(input.selector, noNumb)) {
            return false;
          }
        }
        if (input.validationConfig.maxLength) {
          const lengthCheck = validateMaxLength(input.selector.value, input.validationConfig.maxLength);
          if (!this.triggerValidationEffect(input.selector, lengthCheck)) {
            return false;
          }
        }
        if (input.validationConfig.minLength) {
          const lengthCheck = validateMinLength(input.selector.value, input.validationConfig.minLength);
          if (!this.triggerValidationEffect(input.selector, lengthCheck)) {
            return false;
          }
        }
        if (input.validationConfig.nonLatinCharacters) {
          const latinCharactersCheck = validateNotContainsNonLatinCharacters(input.selector.value);
          if (!this.triggerValidationEffect(input.selector, latinCharactersCheck)) {
            return false;
          }
        }
        return true;
      }
      validateForm({
        inputs
      }) {
        let isValid = true;
        Object.values(inputs).forEach(input => {
          if (input.selector.value.trim() !== '') {
            if (!this.validateInput(input)) {
              isValid = false;
            }
          }
        });
        return isValid;
      }
    }

    const {
      getElementByRef: getElementByRef$i
    } = window.PoleneLibs.Refs;
    const handleNewsletterEventSubscription = async formData => {
      let customerIsSubscribedToEvent = true;
      const errorType = ErrorTypes.formSubmitError;
      let errorMessage;
      const {
        newsletterEventForm,
        messageContainerSuccess,
        messageContainerError,
        messageContainerAlreadySignedUp
      } = getElementByRef$i(['newsletter-event-form', 'message-container-success', 'message-container-error', 'message-container-already-signed-up']);
      if (!newsletterEventForm || !messageContainerSuccess || !messageContainerError || !messageContainerAlreadySignedUp) {
        customerIsSubscribedToEvent = false;
        return {
          customerIsSubscribedToEvent,
          errorType,
          errorMessage
        };
      }
      const {
        eventKey
      } = newsletterEventForm.dataset;
      const customerEmail = formData.get('email');
      if (typeof customerEmail != 'string') {
        messageContainerError.style.display = 'block';
        customerIsSubscribedToEvent = false;
        return {
          customerIsSubscribedToEvent,
          errorType,
          errorMessage
        };
      } else {
        try {
          const response = await fetch(API_KLAVIYO.EVENT, {
            method: 'POST',
            headers: API_KLAVIYO.HEADERS,
            body: JSON.stringify({
              data: {
                type: 'profile',
                attributes: {
                  email: customerEmail,
                  meta: {
                    patch_properties: {
                      append: {
                        event: eventKey
                      }
                    }
                  }
                }
              }
            })
          });
          if (response.status === 202) {
            messageContainerSuccess.style.display = 'block';
            newsletterEventForm.querySelector('input[data-ref="event-form-email"]').value = '';
          } else {
            messageContainerError.style.display = 'block';
          }
        } catch (error) {
          customerIsSubscribedToEvent = false;
        }
        return {
          customerIsSubscribedToEvent,
          errorType,
          errorMessage
        };
      }
    };

    var handleNewsletterEvent = /*#__PURE__*/Object.freeze({
        __proto__: null,
        handleNewsletterEventSubscription: handleNewsletterEventSubscription
    });

    const {
      getElementsByRef: getElementsByRef$9
    } = window.PoleneLibs.Refs;
    class NewsletterEventForm {
      inputs = {};
      constructor({
        formContainerId
      }) {
        this.formContainer = document.getElementById(formContainerId);
        if (!this.formContainer) throw `Unable to find form container with id: ${formContainerId}`;
        this.form = this.formContainer.querySelector('form');
        if (!this.form) throw `Unable to find form in the given container: ${formContainerId}`;
        this.submitButton = this.form.querySelector(FormSelectors.Customer.SUBMIT_BUTTON);
        if (!this.submitButton) throw new Error('Required elements not found');
        this.inputs = {
          email: {
            selector: this.form.querySelector(FormSelectors.Customer.EMAIL),
            validationConfig: FormValidations.email
          }
        };
        this.init();
      }
      initInputValidation({
        inputs
      }) {
        this.inputValidation = new InputValidation({
          formContainer: this.formContainer,
          inputs: inputs
        });
      }
      handleFormValidation = () => {
        if (!this.inputs.email?.selector) return false;
        const isValid = this.inputValidation?.validateForm({
          inputs: this.inputs
        });
        if (this.submitButton) this.submitButton.disabled = !isValid;
        return isValid;
      };
      handleInputValidation = input => {
        if (!input.selector || !input.validationConfig) return false;
        const isValid = this.inputValidation?.validateInput(input);
        if (this.submitButton) this.submitButton.disabled = !isValid;
        return isValid;
      };
      async handleFormSubmit(event) {
        event.preventDefault();
        if (!this.inputValidation?.checkRequiredInputs({
          inputs: this.inputs
        }) || !this.handleFormValidation) return false;
        const form = event.currentTarget;
        const formData = new FormData(form);
        if (this.submitButton) this.submitButton.disabled = true;
        const newsletterEventSubscriptionHandler = await handleNewsletterEventSubscription(formData);
        if (this.submitButton) {
          if (!newsletterEventSubscriptionHandler.customerIsSubscribedToEvent) {
            this.inputValidation?.triggerValidationEffect(this.submitButton, {
              isValid: newsletterEventSubscriptionHandler.customerIsSubscribedToEvent,
              error: newsletterEventSubscriptionHandler.errorType,
              message: newsletterEventSubscriptionHandler.errorMessage
            });
          }
          this.submitButton.disabled = !newsletterEventSubscriptionHandler.customerIsSubscribedToEvent;
        }
      }
      init() {
        this.initInputValidation({
          inputs: this.inputs
        });
        this.form.addEventListener('submit', this.handleFormSubmit.bind(this));
        Object.values(this.inputs).forEach(input => {
          return input.selector.addEventListener('blur', () => this.handleInputValidation(input));
        });
      }
      destroy() {
        this.form.removeEventListener('submit', this.handleFormSubmit.bind(this));
        Object.values(this.inputs).forEach(input => input.selector.removeEventListener('blur', () => this.handleInputValidation(input)));
      }
    }
    var eventForm = async () => {
      const newsletterEventForm = getElementsByRef$9('newsletter-event-form');
      if (newsletterEventForm) {
        try {
          const form = new NewsletterEventForm({
            formContainerId: 'newsletter-event-form-container'
          });
          return () => {
            form.destroy();
          };
        } catch (error) {}
      }
    };

    var eventForm$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: eventForm
    });

    const events$b = window.PoleneLibs.Events.default;
    const {
      storeLanguage: storeLanguage$1
    } = window.PoleneLibs.ConstantsDate;
    const {
      dispatchEvent: dispatchEvent$6
    } = window.PoleneLibs.Utils;
    class ComponentBISForm extends HTMLElement {
      constructor() {
        super();
        this.controller = new AbortController();
      }
      connectedCallback() {
        this.controller = new AbortController();
        this.initializeElements();
        this.setupEventListeners();
      }
      disconnectedCallback() {
        this.controller.abort();
        if (this.container) this.container.dataset.state = '';
      }
      updatedCallback() {
        this.controller.abort();
        this.controller = new AbortController();
        if (this.container) this.container.dataset.state = '';
        this.initializeElements();
        this.setupEventListeners();
      }
      initializeElements = () => {
        const container = this.closest('.bis-form');
        if (container) this.container = container;
        const form = this.querySelector('form');
        if (form) this.form = form;
      };
      setupEventListeners = () => {
        document.addEventListener('modal', event => {
          if (!(event instanceof CustomEvent)) return;
          const {
            submitter,
            type
          } = event.detail;
          if (submitter && type === 'bis') {
            this.submitter = submitter;
            if (this.container) this.container.dataset.state = '';
          }
        });
        if (this.form) {
          this.form.addEventListener('submit', this.handleSubmit, {
            signal: this.controller.signal
          });
        }
        window.addEventListener(events$b.CART_DOM_UPDATED, () => {});
      };
      handleSubmit = async event => {
        event.preventDefault();
        if (this.container && this.form && this.submitter && this.submitter.dataset.variantid) {
          try {
            const formData = new FormData(this.form);
            const variantId = this.submitter.dataset.variantid;
            const newsletterConsentInput = this.form.querySelector('input[id="newsletter-checkbox"]');
            const newsletterConsent = newsletterConsentInput?.checked ?? false;
            formData.set('locale', storeLanguage$1);
            formData.set('variant_id', variantId);
            formData.set('email_marketing_consent', JSON.stringify(newsletterConsent));
            const response = await fetch(`${API_PROXY.BACK_IN_STOCK_SUBSCRIBE}`, {
              method: 'POST',
              body: formData
            });
            if (response.status === 202) {
              this.container.dataset.state = 'submitted';
              const handle = this.submitter.dataset.handle;
              dispatchEvent$6(window, events$b.BIS_SUBSCRIBED, {
                variantId,
                handle,
                newsletterConsent
              });
            } else {
              throw response.status;
            }
          } catch {
            this.container.dataset.state = 'error';
          }
        } else if (this.container) {
          this.container.dataset.state = 'error';
        }
      };
      static define = () => {
        if (!customElements.get('component-bis-form')) customElements.define('component-bis-form', ComponentBISForm);
      };
    }
    var componentBisForm = () => {
      ComponentBISForm.define();
    };

    var componentBisForm$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: componentBisForm
    });

    class LocalizationForm extends HTMLElement {
      abortController = null;
      input = null;
      items = [];
      constructor() {
        super();
      }
      connectedCallback() {
        this.abortController = new AbortController();
        this.initialyzeElements();
        this.setEventListeners();
      }
      disconnectedCallback() {
        this.abortController?.abort();
      }
      initialyzeElements = () => {
        this.input = this.querySelector('input[name="language_code"], input[name="country_code"]');
        this.items = Array.from(this.querySelectorAll('button'));
      };
      setEventListeners = () => {
        this.items.forEach(item => {
          item.addEventListener('click', this.onItemClick, {
            signal: this.abortController?.signal
          });
        });
      };
      onItemClick = event => {
        event.preventDefault();
        const form = this.querySelector('form');
        const target = event.currentTarget;
        if (target.dataset.value && this.input) {
          this.input.value = target.dataset.value;
          if (form) form.submit();
        }
      };
      static define() {
        if (!customElements.get('localization-form')) customElements.define('localization-form', LocalizationForm);
      }
    }
    var localizationForm = () => {
      LocalizationForm.define();
    };

    var localizationForm$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        LocalizationForm: LocalizationForm,
        default: localizationForm
    });

    const {
      isMobile: isMobile$6
    } = window.PoleneLibs.Utils;
    const {
      getElementByRef: getElementByRef$h
    } = window.PoleneLibs.Refs;
    const {
      isFocusable,
      dispatchEvent: dispatchEvent$5
    } = window.PoleneLibs.Utils;
    const {
      ACTIVE_SLIDE_CHANGE,
      PDP_CAROUSEL_GALLERY_SWIPE,
      PDP_CAROUSEL_PACKSHOT_SWIPE
    } = window.PoleneLibs.Events.default;
    const {
      EmblaCarousel,
      EmblaPlugins
    } = window.PoleneVendors;
    const SLIDES_QTY_MARGIN = 2;
    class ComponentCarousel extends HTMLElement {
      controller = undefined;
      embla = undefined;
      autoscrollPlugin = undefined;
      wheelGesturesPlugin = undefined;
      viewport = undefined;
      container = undefined;
      slides = [];
      nextBtn = undefined;
      prevBtn = undefined;
      customNextBtns = [];
      customPrevBtns = [];
      dotsContainer = undefined;
      dots = [];
      showDots = false;
      slidesPerView = undefined;
      slidesPerViewMobile = undefined;
      slideFullPage = false;
      slidesToScroll = 1;
      disableScroll = false;
      loop = false;
      initialSlideIndex = 0;
      ownerEl = null;
      autoscroll = false;
      autoscrollSpeed = 20;
      autoscrollDirection = 1;
      centered = false;
      skipSnap = false;
      dragFree = false;
      containScroll = 'trimSnaps';
      navBtnTriggered = null;
      constructor() {
        super();
      }
      connectedCallback() {
        this.controller = new AbortController();
        this.parseDatasetParams();
        this.initializeElements();
        this.initializeCarousel();
        this.setupEventListeners();
      }
      updatedCallback() {
        this.controller = new AbortController();
        this.parseDatasetParams();
        this.initializeElements();
        this.initializeCarousel();
        this.setupEventListeners();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.embla?.destroy();
      }
      parseDatasetParams = () => {
        const {
          slideFullPage,
          loop,
          showDots,
          initialSlide,
          ownerSelector,
          slidesPerView,
          slidesPerViewMobile,
          slidesToScroll,
          autoscroll,
          autoscrollSpeed,
          autoscrollDirection,
          disableScroll,
          centered,
          centeredMobile,
          skipSnap,
          dragFree,
          customNextBtnsSelector,
          customPrevBtnsSelector
        } = this.dataset;
        this.slideFullPage = slideFullPage === 'true';
        this.loop = loop === 'true';
        this.showDots = showDots === 'true';
        this.initialSlideIndex = initialSlide ? +initialSlide : 0;
        this.ownerEl = ownerSelector ? this.closest(ownerSelector) : null;
        this.slidesPerView = !!slidesPerView ? +slidesPerView : undefined;
        this.slidesPerViewMobile = !!slidesPerViewMobile ? +slidesPerViewMobile : undefined;
        this.slidesToScroll = slidesToScroll ? +slidesToScroll : 1;
        this.autoscroll = autoscroll === 'true';
        this.autoscrollSpeed = autoscrollSpeed ? +autoscrollSpeed : 20;
        this.autoscrollDirection = autoscrollDirection ? +autoscrollDirection : 1;
        this.disableScroll = disableScroll === 'true';
        this.centered = isMobile$6() ? centeredMobile === 'true' : centered === 'true';
        this.skipSnap = skipSnap === 'true';
        this.dragFree = dragFree === 'true';
        this.containScroll = this.loop ? false : this.centered ? isMobile$6() ? 'keepSnaps' : 'trimSnaps' : 'trimSnaps';
        if (this.ownerEl) {
          this.customNextBtns = !!customNextBtnsSelector ? Array.from(this.ownerEl.querySelectorAll(customNextBtnsSelector)) : [];
          this.customPrevBtns = !!customPrevBtnsSelector ? Array.from(this.ownerEl.querySelectorAll(customPrevBtnsSelector)) : [];
        }
      };
      initializeElements = () => {
        try {
          const {
            carouselSlidesViewport,
            carouselPrev,
            carouselNext,
            carouselDotsContainer,
            carouselSlidesContainer
          } = getElementByRef$h(['carousel-slides-viewport', 'carousel-prev', 'carousel-next', 'carousel-dots-container', 'carousel-slides-container'], this);
          this.viewport = carouselSlidesViewport;
          this.container = carouselSlidesContainer;
          if (!this.validateRequirements()) {
            throw new Error('ComponentCarousel minimum requirements are not met.');
          }
          this.dotsContainer = carouselDotsContainer;
          this.nextBtn = carouselNext;
          this.prevBtn = carouselPrev;
        } catch (error) {}
      };
      setupEventListeners = () => {
        this.nextBtn?.addEventListener('click', this.handleNext, {
          signal: this.controller?.signal
        });
        this.prevBtn?.addEventListener('click', this.handlePrev, {
          signal: this.controller?.signal
        });
        this.customNextBtns.forEach(btn => btn.addEventListener('click', this.handleNext, {
          signal: this.controller?.signal
        }));
        this.customPrevBtns.forEach(btn => btn.addEventListener('click', this.handlePrev, {
          signal: this.controller?.signal
        }));
        this.viewport?.addEventListener('mouseleave', this.handleMouseleave, {
          signal: this.controller?.signal
        });
        this.viewport?.addEventListener('focusout', this.handleFocusout, {
          signal: this.controller?.signal
        });
        this.viewport?.addEventListener('blur', this.handleBlur, {
          signal: this.controller?.signal
        });
        this.viewport?.addEventListener('touchend', this.handleTouchend, {
          signal: this.controller?.signal
        });
        if (!this.disableScroll && !EmblaPlugins.WheelGestures) this.viewport?.addEventListener('wheel', this.handleWheel, {
          signal: this.controller?.signal,
          passive: false
        });
      };
      validateRequirements() {
        if (!this.viewport) {
          return false;
        }
        if (!this.slides) {
          return false;
        }
        return true;
      }
      initializeIndexes = () => {
        if (this.dotsContainer) {
          this.dotsContainer.innerHTML = '';
          this.dots = [];
        }
        this.slides.forEach((slide, index) => {
          if (!slide) return;
          slide.dataset.index = index;
          slide.dataset.initialTabIndex = slide.tabIndex.toString();
          if (this.dotsContainer && !slide.dataset.dupOriginIndex) this.setDot(index);
        });
      };
      initializeCarousel = () => {
        if (!this.viewport) return;
        const options = {
          loop: this.loop,
          align: this.centered ? 'center' : 'start',
          startIndex: this.initialSlideIndex,
          slidesToScroll: this.slideFullPage ? 'auto' : this.slidesToScroll,
          containScroll: this.containScroll,
          skipSnaps: this.skipSnap,
          dragFree: this.dragFree,
          direction: this.autoscrollDirection === 1 ? 'ltr' : 'rtl',
          watchDrag: !this.disableScroll,
          watchResize: true,
          watchSlides: true,
          watchFocus: () => this.autoscrollPlugin?.stop(),
          inViewThreshold: 0.5
        };
        const plugins = this.setupPlugins();
        this.embla = EmblaCarousel(this.viewport, options, plugins);
        this.slides = this.embla.slideNodes();
        this.setupEmblaEvents();
        this.duplicateSlides();
        this.initializeIndexes();
      };
      setDot = index => {
        const dot = document.createElement('button');
        dot.setAttribute('data-ref', 'carousel-dot');
        dot.setAttribute('data-index', index.toString());
        dot.setAttribute('type', 'button');
        dot.setAttribute('aria-label', `Go to slide ${index + 1}`);
        dot.addEventListener('click', this.handleDotClick, {
          signal: this.controller?.signal
        });
        this.dotsContainer?.appendChild(dot);
        this.dots.push(dot);
      };
      setupPlugins = () => {
        const plugins = [];
        if (this.autoscroll && this.loop) {
          this.autoscrollPlugin = EmblaPlugins.AutoScroll({
            speed: this.autoscrollSpeed / 16,
            stopOnInteraction: true,
            stopOnFocusIn: true,
            stopOnMouseEnter: true,
            direction: this.autoscrollDirection === 1 ? 'forward' : 'backward',
            playOnInit: true,
            startDelay: 0
          });
          plugins.push(this.autoscrollPlugin);
        }
        if (!this.disableScroll && EmblaPlugins.WheelGestures) {
          this.wheelGesturesPlugin = EmblaPlugins.WheelGestures({
            forceWheelAxis: 'x'
          });
          plugins.push(this.wheelGesturesPlugin);
        }
        return plugins;
      };
      setupEmblaEvents = () => {
        if (!this.embla) return;
        this.embla.on('select', this.onSelect);
        this.embla.on('init', this.onInit);
        this.embla.on('reInit', this.onReInit);
        this.embla.on('settle', this.onSettle);
        this.embla.on('slidesInView', this.onSlideInView);
      };
      onInit = () => {
        this.updateDots();
        this.updateButtonsState();
      };
      onReInit = () => {
        this.updateDots();
        this.updateButtonsState();
      };
      onSelect = () => {
        this.updateDots();
        this.updateButtonsState();
        this.dispatchActiveSlideChangeEvent();
        if (this.id && this.id.includes('gallery')) {
          dispatchEvent$5(window, PDP_CAROUSEL_GALLERY_SWIPE, {
            carousel_id: this.id
          });
        } else if (this.id && this.id.includes('packshot')) {
          dispatchEvent$5(window, PDP_CAROUSEL_PACKSHOT_SWIPE, {
            carousel_id: this.id
          });
        }
      };
      onSettle = () => {
        this.focusOnSettle();
      };
      onSlideInView = () => {
        const slidesInView = this.embla?.slidesInView();
        const slidesNotInView = this.embla?.slidesNotInView();
        if (!this.embla?.canScrollPrev() && !this.embla?.canScrollNext()) {
          this.dataset.centered = 'true';
        } else {
          this.dataset.centered = 'false';
        }
        if (this.dataset.ref && this.dataset.ref === 'fs-colors-carousel' && isMobile$6() && slidesInView && slidesInView.length < 5 && slidesNotInView && slidesNotInView.length === 0) {
          this.classList.add('mobile-centered');
        } else {
          this.classList.remove('mobile-centered');
        }
        if (this.classList.contains('reveal-manual')) {
          this.classList.add('is-revealed');
        }
        slidesInView?.forEach(slideIndex => this.setSlideAccessibility(this.slides[slideIndex], true));
        slidesNotInView?.forEach(slideIndex => this.setSlideAccessibility(this.slides[slideIndex], false));
      };
      setSlideAccessibility = (slide, isVisible) => {
        if (!slide) return;
        if (!slide.dataset.initialTabIndex) slide.dataset.initialTabIndex = slide.tabIndex.toString() ?? '0';
        if (isVisible) {
          slide.setAttribute('tabindex', slide.dataset.initialTabIndex ?? '0');
          slide.setAttribute('aria-hidden', 'false');
          Array.from(slide.querySelectorAll(FOCUSABLE_SELECTORS)).forEach(child => {
            if (!child.dataset.initialTabIndex) child.dataset.initialTabIndex = child.tabIndex.toString() ?? '0';
            child.setAttribute('tabindex', child.dataset.initialTabIndex ?? '0');
          });
        } else {
          slide.setAttribute('tabindex', '-1');
          slide.setAttribute('aria-hidden', 'true');
          Array.from(slide.querySelectorAll(FOCUSABLE_SELECTORS)).forEach(child => {
            if (!child.dataset.initialTabIndex) child.dataset.initialTabIndex = child.tabIndex.toString() ?? '0';
            child.setAttribute('tabindex', '-1');
          });
        }
      };
      duplicateSlides = () => {
        if (!this.container || !this.loop || !this.slidesPerView && !this.slidesPerViewMobile) return;
        const minRequiredSlides = Math.max(this.slidesPerView ?? 0, this.slidesPerViewMobile ?? 0) + SLIDES_QTY_MARGIN;
        if (this.slides.length === 0 || this.slides.length >= minRequiredSlides) return;
        const originalSlides = this.slides.filter(slide => slide != undefined);
        while (this.slides.length < minRequiredSlides) {
          const dupSlides = originalSlides.map(slide => slide.cloneNode(true));
          dupSlides.forEach((slide, index) => {
            slide.dataset.dupOriginIndex = index.toString();
            if (this.container) this.container.appendChild(slide);
          });
          this.slides = this.slides.concat(dupSlides);
        }
      };
      handleNext = () => {
        if (this.loop && this.autoscroll) this.autoscrollPlugin?.stop();
        this.embla?.scrollNext();
        this.navBtnTriggered = 'next';
      };
      handlePrev = () => {
        if (this.loop && this.autoscroll) this.autoscrollPlugin?.stop();
        this.embla?.scrollPrev();
        this.navBtnTriggered = 'prev';
      };
      handleMouseleave = () => this.autoscrollPlugin?.play();
      handleFocusout = () => this.autoscrollPlugin?.play();
      handleBlur = () => this.autoscrollPlugin?.play();
      handleTouchend = () => this.autoscrollPlugin?.play();
      handleWheel = event => {
        if (!this.embla) return;
        const isHorizontalScroll = Math.abs(event.deltaX) > Math.abs(event.deltaY);
        if (isHorizontalScroll) {
          event.preventDefault();
          if (event.deltaX > 0) {
            this.embla.scrollNext();
          } else if (event.deltaX < 0) {
            this.embla.scrollPrev();
          }
        }
      };
      handleDotClick = event => {
        const target = event.currentTarget;
        const dotIndex = target.dataset.index;
        if (!this.embla || !dotIndex) return;
        const selectedIndex = this.embla.selectedScrollSnap();
        const selectedSlide = this.slides[selectedIndex];
        const {
          dupOriginIndex
        } = selectedSlide.dataset;
        if (dupOriginIndex && +dupOriginIndex === dotIndex) return;
        this.embla.scrollTo(dotIndex);
      };
      updateDots = () => {
        if (!this.embla || !this.showDots || this.dots.length === 0) return;
        const selectedIndex = this.embla.selectedScrollSnap();
        const selectedSlide = this.slides[selectedIndex];
        const dotIndex = selectedSlide.dataset.dupOriginIndex ? +selectedSlide.dataset.dupOriginIndex : selectedIndex;
        this.dots.forEach((dot, index) => {
          const isActive = index === dotIndex;
          dot.classList.toggle('active', isActive);
          dot.setAttribute('aria-current', isActive ? 'true' : 'false');
        });
      };
      updateButtonsState = () => {
        if (!this.embla) return;
        const canScrollPrev = this.embla.canScrollPrev();
        const canScrollNext = this.embla.canScrollNext();
        const hasScrollContent = this.loop || canScrollPrev || canScrollNext;
        const disableScrollPrev = !canScrollPrev && !this.loop;
        const disableScrollNext = !canScrollNext && !this.loop;
        const setArrowsVisibility = visible => {
          const ariaHidden = visible ? 'false' : 'true';
          this.prevBtn?.setAttribute('aria-hidden', ariaHidden);
          this.nextBtn?.setAttribute('aria-hidden', ariaHidden);
          this.prevBtn?.classList.toggle('is-visible', visible);
          this.nextBtn?.classList.toggle('is-visible', visible);
          this.customPrevBtns.forEach(btn => {
            btn.setAttribute('aria-hidden', ariaHidden);
            btn.classList.toggle('is-visible', visible);
          });
          this.customNextBtns.forEach(btn => {
            btn.setAttribute('aria-hidden', ariaHidden);
            btn.classList.toggle('is-visible', visible);
          });
        };
        setArrowsVisibility(hasScrollContent);
        if (this.prevBtn) {
          this.prevBtn.disabled = disableScrollPrev;
          this.prevBtn.setAttribute('aria-disabled', disableScrollPrev.toString());
          this.customPrevBtns.forEach(btn => {
            btn.disabled = disableScrollPrev;
            btn.setAttribute('aria-disabled', disableScrollPrev.toString());
          });
        }
        if (this.nextBtn) {
          this.nextBtn.disabled = disableScrollNext;
          this.nextBtn.setAttribute('aria-disabled', disableScrollNext.toString());
          this.customNextBtns.forEach(btn => {
            btn.disabled = disableScrollNext;
            btn.setAttribute('aria-disabled', disableScrollNext.toString());
          });
        }
      };
      focusOnSettle = () => {
        if (!this.navBtnTriggered) return;
        const slidesIndexes = this.embla?.slidesInView();
        if (this.slides.length > 0 && slidesIndexes && slidesIndexes.length > 0) {
          const targetIndex = this.navBtnTriggered === 'next' ? slidesIndexes[0] : slidesIndexes[slidesIndexes.length - 1];
          this.getFocusableElem(this.slides[targetIndex])?.focus();
        }
        this.navBtnTriggered = null;
      };
      dispatchActiveSlideChangeEvent = () => {
        if (!this.embla) return;
        const selectedIndex = this.embla.selectedScrollSnap();
        const activeSlide = this.slides[selectedIndex];
        if (activeSlide) {
          const event = new CustomEvent(ACTIVE_SLIDE_CHANGE, {
            detail: {
              slideIndex: selectedIndex,
              slide: activeSlide
            },
            bubbles: true
          });
          (this.ownerEl || this).dispatchEvent(event);
        }
      };
      getFocusableElem(root) {
        if (isFocusable(root)) return root;
        return root.querySelector(FOCUSABLE_SELECTORS);
      }
      scrollToIndex = (index, removeTransition = false) => {
        if (index >= this.slides.length || index < 0) return;
        this.embla?.scrollTo(index, removeTransition);
      };
      reInit = () => {
        this.embla?.reInit();
      };
      static define = () => {
        if (!customElements.get('component-carousel')) {
          customElements.define('component-carousel', ComponentCarousel);
        }
      };
    }
    var componentCarousel = () => {
      ComponentCarousel.define();
    };

    var componentCarousel$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        ComponentCarousel: ComponentCarousel,
        default: componentCarousel
    });

    const events$a = window.PoleneLibs.Events.default;
    const {
      dispatchEvent: dispatchEvent$4
    } = window.PoleneLibs.Utils;
    const {
      ModalEvent
    } = window.PoleneLibs.ModalEvents;
    const {
      isMobile: isMobile$5
    } = window.PoleneLibs.Utils;
    class ComponentModal extends HTMLElement {
      static FOCUS_DELAY = 100;
      controller = undefined;
      backdrop = null;
      closeButton = null;
      extOpenTrigger = null;
      extCloseTrigger = null;
      focusTimeout = null;
      fsModalClassInitiallyPresent = false;
      triggerScope = 'parent';
      isOpen = false;
      hideMessengerPopup = false;
      focusTrap = null;
      constructor() {
        super();
      }
      connectedCallback() {
        this.controller = new AbortController();
        this.triggerScope = this.dataset.triggerScope || 'parent';
        this.initializeElements();
        this.applyAccessibility();
      }
      updatedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.triggerScope = this.dataset.triggerScope || 'parent';
        this.isOpen = false;
        if (this.focusTimeout) {
          clearTimeout(this.focusTimeout);
          this.focusTimeout = null;
        }
        this.initializeElements();
        this.applyAccessibility();
      }
      disconnectedCallback() {
        document.body.style.overflow = '';
        this.controller?.abort();
      }
      initializeElements = () => {
        const {
          openSelector,
          closeSelector,
          hideMessengerPopup
        } = this.dataset;
        this.hideMessengerPopup = hideMessengerPopup === 'true';
        if (this.nextElementSibling?.matches('.component-modal__backdrop')) {
          const backdrop = this.nextElementSibling;
          if (backdrop) this.backdrop = backdrop;
        }
        this.closeButton = this.querySelector('.component-modal__close');
        const root = this.triggerScope === 'parent' ? this.parentElement : document;
        if (root) {
          if (!!openSelector) this.extOpenTrigger = root.querySelectorAll(openSelector);
          if (!!closeSelector) this.extCloseTrigger = root.querySelectorAll(closeSelector);
        }
        this.setupEventListeners();
      };
      setupEventListeners = () => {
        this.extOpenTrigger?.forEach(trigger => {
          trigger.addEventListener('click', () => this.open(trigger), {
            signal: this.controller?.signal
          });
        });
        this.extCloseTrigger?.forEach(trigger => {
          trigger.addEventListener('click', this.close, {
            signal: this.controller?.signal
          });
        });
        this.closeButton?.addEventListener('click', this.close, {
          signal: this.controller?.signal
        });
        this.addEventListener('click', this.handleOverlayClick, {
          signal: this.controller?.signal
        });
        if (this.backdrop) {
          this.backdrop.addEventListener('click', this.close, {
            signal: this.controller?.signal
          });
        }
      };
      applyAccessibility = () => {
        this.removeEventListener('keydown', this.handleKeyDown);
        this.addEventListener('keydown', this.handleKeyDown, {
          signal: this.controller?.signal
        });
      };
      handleOverlayClick = e => {
        if (e.target === this) this.close();
      };
      handleKeyDown = e => {
        if (e.key === 'Escape') {
          this.close();
        }
      };
      open = trigger => {
        if (this.isOpen === true) return;
        if (document.body.classList.contains('fullscreen-active')) this.fsModalClassInitiallyPresent = true;
        if (this.dataset.fullscreen === 'true') document.body.classList.add('fullscreen-active');
        this.classList.add('active');
        this.ariaHidden = 'false';
        document.body.style.overflow = 'hidden';
        this.isOpen = true;
        this.focusTrap = new FocusTrap(this);
        setTimeout(() => {
          this.focusTrap?.activate();
        }, ComponentModal.FOCUS_DELAY);
        if (isMobile$5() || this.hideMessengerPopup) {
          window?.zE?.('messenger', 'hide');
        }
        document.dispatchEvent(new ModalEvent(this.dataset.type || 'modal', 'open', trigger || null));
        if (this.dataset.type === 'bis') {
          const variantId = trigger?.dataset.variantid;
          const handle = trigger?.dataset.handle;
          dispatchEvent$4(window, events$a.TOGGLE_BIS, {
            variantId,
            handle
          });
        }
      };
      close = () => {
        this.classList.remove('active');
        this.classList.add('closing');
        this.focusTrap?.deactivate();
        setTimeout(() => {
          if (this.isOpen === false) return;
          if (this.dataset.fullscreen === 'true' && !this.fsModalClassInitiallyPresent) document.body.classList.remove('fullscreen-active');
          this.classList.remove('closing');
          this.ariaHidden = 'true';
          document.body.style.overflow = '';
          if (this.focusTimeout) clearTimeout(this.focusTimeout);
          this.isOpen = false;
        }, ComponentModal.FOCUS_DELAY);
        if (isMobile$5() || this.hideMessengerPopup) {
          window?.zE?.('messenger', 'show');
        }
        document.dispatchEvent(new ModalEvent(this.dataset.type || 'modal', 'close', null));
      };
      reInit = () => {
        this.initializeElements();
      };
      static define() {
        if (!customElements.get('component-modal')) {
          customElements.define('component-modal', ComponentModal);
        }
      }
    }
    var componentModal = () => {
      ComponentModal.define();
    };

    var componentModal$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        ComponentModal: ComponentModal,
        default: componentModal
    });

    const {
      getElementByRef: getElementByRef$g
    } = window.PoleneLibs.Refs;
    class ComponentProductCard extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        this.init();
      }
      disconnectedCallback() {}
      init() {
        this.handleImgLoad();
      }
      handleImgLoad = () => {
        const {
          productCardImg
        } = getElementByRef$g('product-card-img', this);
        if (!productCardImg) return;
        const {
          imgSrc
        } = productCardImg.dataset;
        const pImg = new Image();
        if (imgSrc) {
          pImg.src = imgSrc;
          pImg.addEventListener('load', () => {
            if (productCardImg?.parentNode instanceof HTMLElement) {
              productCardImg.parentNode.classList.add('is-visible');
            }
          });
        }
      };
      static define() {
        if (!customElements.get('component-product-card')) {
          customElements.define('component-product-card', ComponentProductCard);
        }
      }
    }
    var componentProductCard = () => {
      ComponentProductCard.define();
    };

    var componentProductCard$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: componentProductCard
    });

    const {
      wrappedLoader
    } = window.PoleneLibs.ElementTemplates;
    const events$9 = window.PoleneLibs.Events.default;
    const {
      dispatchEvent: dispatchEvent$3,
      parseProductForm
    } = window.PoleneLibs.Utils;
    const {
      getRefs: getRefs$7,
      getElementByRef: getElementByRef$f
    } = window.PoleneLibs.Refs;
    const {
      morphSection
    } = window.PoleneLibs.SectionRenderer;
    const root = window.Shopify?.routes.root;
    const selectors$5 = {
      cartCounter: '.js-cart-counter',
      variantInput: '.js-variant-input'
    };
    const fetchCart = async () => {
      try {
        const response = await fetch(root + 'cart.js', {
          method: 'GET'
        });
        const cart = await response.json();
        fetchHandler(cart);
      } catch (error) {}
    };
    const updateCartContent = async (section, json) => {
      try {
        const cartComponent = document.querySelector('component-cart-items');
        const sectionId = cartComponent?.getAttribute('data-section-id') || 'main-cart';
        await morphSection(sectionId, section);
        dispatchEvent$3(window, events$9.CART_UPDATED, json);
        dispatchEvent$3(window, events$9.CART_DOM_UPDATED);
      } catch (error) {
        const {
          cart
        } = getRefs$7();
        if (cart) {
          cart.innerHTML = section;
          setCartCount(0);
        }
      }
    };
    const fetchHandler = cart => {
      updateCartCount(cart);
      dispatchEvent$3(window, events$9.CART_FETCHED, cart);
    };
    const updateCartCount = cart => {
      setTimeout(() => {
        setCartCount(cart.item_count);
      });
    };
    const setCartCount = amount => {
      const counters = document.querySelectorAll(selectors$5.cartCounter);
      counters.forEach(counter => {
        const currentText = counter.innerHTML;
        const newText = counter.classList.contains('visually-hidden') ? currentText.replace(/\d+/, amount.toString()) : amount.toString();
        counter.innerHTML = newText;
      });
    };
    const triggeredProductForm = {};
    const handleAddToCart = async ({
      productForm,
      submitBtn,
      submitBtns
    }) => {
      const forms = Array.isArray(productForm) ? productForm : [productForm];
      const form = forms[0];
      const formData = new FormData(form);
      const items = parseProductForm(formData);
      const inputs = form.querySelectorAll('input');
      if (!submitBtn) return;
      const uniqueBtns = new Set([submitBtn]);
      if (submitBtns) submitBtns.forEach(btn => uniqueBtns.add(btn));
      const allBtns = Array.from(uniqueBtns);
      const defaultStates = new Map();
      allBtns.forEach(btn => defaultStates.set(btn, btn.dataset.state));
      let eContainer;
      const states = {
        success: 'success',
        loading: 'loading',
        default: 'default',
        disabled: 'disabled'
      };
      if (submitBtn.dataset.state == states.disabled) {
        let variantId = null;
        if (!items.length) {
          variantId = form.querySelectorAll(selectors$5.variantInput)[0].value;
        } else {
          variantId = items[0].id;
          const hasOptions = form.getElementsByTagName('option');
          if (hasOptions && items[0].id === '0') {
            variantId = form.getElementsByTagName('option')[1].value;
          }
        }
        const handle = form.dataset.handle || form.querySelector('input[data-handle]')?.value || form.closest('[data-handle]')?.dataset.handle;
        dispatchEvent$3(window, events$9.TOGGLE_BIS, {
          variantId,
          handle
        });
        return;
      }
      const nextElementSibling = form.closest('[data-ref="product-card"]') || form.nextElementSibling;
      if (nextElementSibling) {
        const {
          errorContainer
        } = getRefs$7(nextElementSibling);
        eContainer = errorContainer;
      }
      allBtns.forEach(btn => {
        if (!btn.firstElementChild) {
          btn.innerHTML = wrappedLoader;
        }
        btn.dataset.state = states.loading;
      });
      const cartComponent = document.querySelector('component-cart-items');
      const sectionId = cartComponent?.getAttribute('data-section-id') || 'main-cart';
      const resetBtnsState = () => {
        allBtns.forEach(btn => {
          const originalState = defaultStates.get(btn);
          if (originalState !== undefined) btn.dataset.state = originalState;
        });
      };
      try {
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items,
            sections: `${sectionId},cart-notification-content`
          })
        });
        const json = await response.json();
        if (response.ok) {
          if (cartComponent && json.sections && json.sections[sectionId]) {
            await updateCartContent(json.sections[sectionId], json);
          }
          dispatchEvent$3(window, events$9.CART_UPDATED, json);
          allBtns.forEach(btn => {
            btn.dataset.state = states.success;
          });
          if (eContainer && eContainer.innerHTML) eContainer.innerHTML = '';
          const buttonsWithLabels = [];
          allBtns.forEach(btn => {
            const {
              defaultLabel,
              successLabel
            } = getElementByRef$f(['default-label', 'success-label'], btn);
            if (defaultLabel && successLabel) {
              buttonsWithLabels.push({
                btn,
                defaultLabel,
                successLabel
              });
              defaultLabel.classList.add('is-hidden');
              defaultLabel.setAttribute('aria-hidden', 'true');
              successLabel.classList.remove('is-hidden');
              successLabel.setAttribute('aria-hidden', 'false');
            }
          });
          setTimeout(() => {
            buttonsWithLabels.forEach(({
              defaultLabel,
              successLabel
            }) => {
              defaultLabel.classList.remove('is-hidden');
              defaultLabel.setAttribute('aria-hidden', 'false');
              successLabel.classList.add('is-hidden');
              successLabel.setAttribute('aria-hidden', 'true');
            });
            resetBtnsState();
          }, 3000);
          const handleKey = form.dataset.handle;
          if (!handleKey) return;
          if (handleKey in triggeredProductForm) {
            clearTimeout(triggeredProductForm[handleKey]);
            delete triggeredProductForm[handleKey];
          }
          triggeredProductForm[handleKey] = setTimeout(() => {
            resetBtnsState();
            inputs.forEach(input => {
              input.checked = false;
            });
            clearTimeout(triggeredProductForm[handleKey]);
            delete triggeredProductForm[handleKey];
          }, 3000);
        } else {
          resetBtnsState();
          if (eContainer) {
            eContainer.innerHTML = json.description;
            setTimeout(() => {
              eContainer.innerHTML = '';
            }, 5000);
          }
        }
      } catch (error) {
        resetBtnsState();
      }
    };

    const {
      getElementByRef: getElementByRef$e,
      getElementsByRef: getElementsByRef$8
    } = window.PoleneLibs.Refs;
    const events$8 = window.PoleneLibs.Events.default;
    const {
      dispatchEvent: dispatchEvent$2,
      isMobile: isMobile$4,
      updateBisModal: updateBisModal$1
    } = window.PoleneLibs.Utils;
    const selectors$4 = {
      sizeSelector: '.js-size-selector',
      productForm: '.js-product-form',
      productAnchor: '.js-product-anchor',
      addToCart: '.js-add-to-cart',
      faveBtn: '.js-fave-btn'
    };
    const classes$8 = {
      preorderInput: 'preorder-note',
      mobile: 'is-mobile',
      preorderOverlay: 'is-preorder-overlay'
    };
    class ComponentProductForm extends HTMLElement {
      productForm = this.getElementsByTagName('form')[0];
      submitBtns = Array.from(this.querySelectorAll('button[type="submit"]'));
      formErrors = this.querySelector('[data-ref="form-errors"]');
      isProcessingAddToCart = false;
      resetTimeout = 0;
      formType = 'basic';
      isVariants = this.submitBtns.some(btn => btn.dataset.isVariants === 'true');
      constructor() {
        super();
      }
      connectedCallback() {
        this.init();
      }
      disconnectedCallback() {
        this.productForm.removeEventListener('input', this.handleFormChange);
        this.productForm.removeEventListener('submit', this.handleFormSubmit);
        if (this.productForm) {
          this.productForm.removeEventListener('input', this.handleFormChange);
        }
        const labels = this.querySelectorAll('.product-size-selector__variants__variant__label');
        labels.forEach(label => {
          label.removeEventListener('keydown', this.handleRadioLabelKeydown);
        });
      }
      init() {
        this.formType = this.dataset.formType || 'basic';
        if (this.productForm) {
          if (this.formType !== 'quick' || this.formType === 'quick' && !isMobile$4()) {
            this.productForm.addEventListener('input', this.handleFormChange);
            this.productForm.addEventListener('change', this.handleFormChange);
          }
          this.productForm.addEventListener('submit', this.handleFormSubmit);
        }
        if (this.submitBtns.length > 0) {
          this.submitBtns.forEach(btn => {
            btn.addEventListener('click', this.handleFormErrors);
          });
        }
        this.setupRadioLabelKeydown();
      }
      resetErrors = () => {
        if (this.formErrors) {
          this.formErrors.querySelectorAll('span').forEach(error => {
            error.classList.remove('is-visible');
          });
        }
      };
      handleFormErrors = event => {
        this.resetErrors();
        const target = event.currentTarget;
        if (target?.dataset.state === 'disabled') {
          const {
            errorNoSizeSelected
          } = getElementByRef$e('error-no-size-selected', this);
          if (errorNoSizeSelected) errorNoSizeSelected.classList.add('is-visible');
        }
      };
      setupRadioLabelKeydown = () => {
        const labels = this.querySelectorAll('.product-size-selector__variants__variant__label');
        if (labels.length > 0) {
          labels.forEach(label => {
            label.addEventListener('keydown', this.handleRadioLabelKeydown);
          });
        }
      };
      handleRadioLabelKeydown = event => {
        if (event.key !== 'Enter') return;
        const label = event.currentTarget;
        if (!label || !label.htmlFor) return;
        const radioButton = document.getElementById(label.htmlFor);
        if (radioButton && radioButton.type === 'radio' && this.productForm.contains(radioButton)) {
          event.preventDefault();
          radioButton.click();
        }
      };
      updatePreorderInputsState = targetElement => {
        const {
          preorderInputs: selectedPreorderInputs
        } = getElementByRef$e('preorder-inputs', targetElement);
        const {
          preorderInputs
        } = getElementsByRef$8('preorder-inputs', this.productForm);
        const allPreorderInputs = Array.isArray(preorderInputs) ? preorderInputs : [preorderInputs];
        const toggleInputsDisabled = (container, disabled) => {
          if (!container) return;
          container.querySelectorAll('input').forEach(input => {
            if (disabled) {
              input.setAttribute('disabled', 'true');
            } else {
              input.removeAttribute('disabled');
            }
          });
        };
        if (allPreorderInputs) {
          allPreorderInputs.forEach(preorderInput => {
            if (preorderInput) toggleInputsDisabled(preorderInput, true);
          });
        }
        if (selectedPreorderInputs) toggleInputsDisabled(selectedPreorderInputs, false);
      };
      isInCartNotification = () => {
        return Boolean(this.closest('[data-ref="cart-notification"]'));
      };
      handleFormChange = event => {
        this.resetErrors();
        if (!(event.target instanceof HTMLElement)) return;
        let dataset;
        let value;
        if (event.target instanceof HTMLSelectElement) {
          const selected = event.target.selectedOptions && event.target.selectedOptions[0];
          dataset = selected?.dataset;
          value = selected?.value || event.target.value;
          if (event.target.name !== 'id') {
            event.target.setAttribute('name', 'id');
          }
        } else if (event.target instanceof HTMLInputElement) {
          dataset = event.target.dataset;
          value = event.target.value;
        } else {
          return;
        }
        if (this.isProcessingAddToCart) return;
        if (event.target instanceof HTMLSelectElement && value) {
          let hiddenIdInput = this.productForm.querySelector('input[name="id"]');
          if (!hiddenIdInput) {
            hiddenIdInput = document.createElement('input');
            hiddenIdInput.type = 'hidden';
            hiddenIdInput.name = 'id';
            this.productForm.appendChild(hiddenIdInput);
          }
          hiddenIdInput.value = value;
        }
        if (event.target instanceof HTMLInputElement && event.target.type === 'radio' && event.target.name === 'variant_size') {
          const radioValue = event.target.value;
          if (radioValue) {
            let hiddenIdInput = this.productForm.querySelector('input[name="id"]');
            if (!hiddenIdInput) {
              hiddenIdInput = document.createElement('input');
              hiddenIdInput.type = 'hidden';
              hiddenIdInput.name = 'id';
              this.productForm.appendChild(hiddenIdInput);
            }
            hiddenIdInput.value = radioValue;
          }
        }
        if (dataset?.state && dataset?.label && this.submitBtns.length > 0) {
          this.submitBtns.forEach(btn => {
            const {
              defaultLabel
            } = getElementByRef$e('default-label', btn);
            if (defaultLabel) defaultLabel.textContent = dataset.label;
            btn.dataset.state = dataset.state;
            btn.classList.toggle('bis-modal-trigger', dataset.state === 'disabled');
            updateBisModal$1();
            if (event.target instanceof HTMLInputElement) btn.dataset.variantid = event.target.value;
          });
          const {
            productContext
          } = getElementByRef$e('product-context', this);
          if (productContext) {
            productContext.innerHTML = dataset?.context ? dataset.context : '&nbsp;';
          }
          const targetParent = event.target.parentElement;
          const scope = event.target instanceof HTMLSelectElement ? this.productForm : targetParent;
          if (scope) {
            this.updatePreorderInputsState(scope);
          }
        } else if (dataset?.availability == 'false') {
          const handle = this.dataset.handle;
          dispatchEvent$2(window, events$8.TOGGLE_BIS, {
            variantId: value,
            handle
          });
          return;
        }
        if (this.formType === 'quick' && this.submitBtns.length > 0 && this.submitBtns[0].dataset.state === 'active') {
          this.handleQuickAddToCart();
        }
        return;
      };
      handleQuickAddToCart = () => {
        if (!this.productForm || this.submitBtns.length === 0) return;
        const submitBtn = this.submitBtns[0];
        if (this.isProcessingAddToCart) return;
        if (submitBtn.dataset.state === 'inactive' || submitBtn.dataset.state === 'disabled' || submitBtn.dataset.state === 'modal') {
          return;
        }
        if (this.classList.contains('quick-buy-form') && this.productForm.querySelector(selectors$4.sizeSelector) && isMobile$4() && !this.isInCartNotification()) {
          this.updateCartNotification(this.productForm, classes$8.mobile, 'variantSelector');
          return;
        }
        const preOrderInput = this.productForm.getElementsByClassName(classes$8.preorderInput);
        if (preOrderInput.length && isMobile$4()) {
          this.updateCartNotification(this.productForm, classes$8.preorderOverlay, 'preorder');
          return;
        }
        this.isProcessingAddToCart = true;
        handleAddToCart({
          productForm: this.productForm,
          submitBtn,
          submitBtns: this.submitBtns
        });
        setTimeout(() => {
          this.isProcessingAddToCart = false;
        }, 1000);
      };
      handleFormSubmit = event => {
        this.resetErrors();
        if (!(event.currentTarget instanceof HTMLElement)) return;
        event.preventDefault();
        const productForm = event.currentTarget;
        const submitBtn = event.submitter;
        if (this.isProcessingAddToCart || !submitBtn || !productForm) return;
        const preOrderInput = productForm.getElementsByClassName(classes$8.preorderInput);
        if (this.isVariants && isMobile$4()) return;
        if (preOrderInput.length && isMobile$4()) {
          this.updateCartNotification(productForm, classes$8.preorderOverlay, 'preorder');
          return;
        }
        if (submitBtn && (submitBtn.dataset.state === 'inactive' || submitBtn.dataset.state === 'modal')) {
          return;
        }
        this.isProcessingAddToCart = true;
        handleAddToCart({
          productForm,
          submitBtn,
          submitBtns: this.submitBtns
        });
        setTimeout(() => {
          this.isProcessingAddToCart = false;
        }, 1000);
      };
      updateCartNotification = (form, className, state) => {
        if (this.isProcessingAddToCart) {
          clearTimeout(this.resetTimeout);
        }
        this.isProcessingAddToCart = true;
        const clone = form.cloneNode(true);
        let elementForNotification = clone;
        if (state === 'variantSelector') {
          elementForNotification = this.cloneNode(true);
        }
        const hostHandle = this?.dataset?.handle;
        const resolvedHandle = form?.dataset?.handle || hostHandle;
        if (resolvedHandle && elementForNotification?.setAttribute) {
          elementForNotification.setAttribute('data-handle', String(resolvedHandle));
        }
        this.resetTimeout = Number(setTimeout(() => {
          this.isProcessingAddToCart = false;
        }, 500));
      };
      static define() {
        if (!customElements.get('component-product-form')) {
          customElements.define('component-product-form', ComponentProductForm);
        }
      }
    }
    var componentProductForm = () => {
      ComponentProductForm.define();
    };

    var componentProductForm$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: componentProductForm
    });

    class ComponentDrawer extends HTMLElement {
      previousActiveElement = null;
      constructor() {
        super();
        this.elements = {
          closeButton: null,
          focusableElements: null
        };
      }
      connectedCallback() {
        this.initializeElements();
        this.setupEventListeners();
      }
      disconnectedCallback() {
        this.removeEventListeners();
      }
      initializeElements = () => {
        this.elements.closeButton = this.querySelector('[data-ref="drawer-close-btn"]');
        this.elements.focusableElements = Array.from(this.querySelectorAll(FOCUSABLE_SELECTORS));
      };
      setupEventListeners = () => {
        this.addEventListener('keydown', this.handleKeyDown);
        this.addEventListener('click', this.handleClick);
        this.elements.closeButton?.addEventListener('click', this.close);
      };
      removeEventListeners = () => {
        this.removeEventListener('keydown', this.handleKeyDown);
        this.removeEventListener('click', this.handleClick);
        this.elements.closeButton?.removeEventListener('click', this.close);
      };
      handleClick = e => {
        if (e.target === this) this.close();
      };
      handleKeyDown = e => {
        switch (e.key) {
          case 'Escape':
            this.close();
            break;
          case 'Tab':
            this.manageFocus(e);
            break;
          case 'Enter':
            this.manageEnter(e);
            break;
        }
      };
      manageEnter = e => {
        e.preventDefault();
        e.target?.dispatchEvent(new PointerEvent('click'));
      };
      manageFocus = e => {
        const elements = this.elements.focusableElements;
        if (!elements?.length) return;
        const firstElement = elements[0];
        const lastElement = elements[elements.length - 1];
        const isTabbing = !e.shiftKey;
        const isReverseTabbing = e.shiftKey;
        if (isReverseTabbing && document.activeElement === firstElement) {
          lastElement.focus();
          e.preventDefault();
        } else if (isTabbing && document.activeElement === lastElement) {
          firstElement.focus();
          e.preventDefault();
        }
      };
      open = () => {
        this.previousActiveElement = document.activeElement ?? null;
        document.body.classList.add('drawer-open');
        this.classList.add('active');
        this.ariaHidden = 'false';
        this.ariaExpanded = 'true';
        setTimeout(() => {
          if (this.elements.focusableElements) this.elements.focusableElements[0].focus();
        }, 100);
        document.body.style.overflow = 'hidden';
      };
      close = () => {
        document.body.classList.remove('drawer-open');
        this.classList.remove('active');
        this.ariaHidden = 'true';
        this.ariaExpanded = 'false';
        this.previousActiveElement?.focus();
        document.body.style.overflow = 'visible';
        window?.zE?.('messenger', 'show');
      };
      static define = () => {
        if (!customElements.get('component-drawer')) {
          customElements.define('component-drawer', ComponentDrawer);
        }
      };
    }
    var componentDrawer = () => {
      ComponentDrawer.define();
    };

    var componentDrawer$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        ComponentDrawer: ComponentDrawer,
        default: componentDrawer
    });

    const validateEmail = email => {
      if (/^[\w+.-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email)) {
        return true;
      }
      return false;
    };

    const events$7 = window.PoleneLibs.Events.default;
    const {
      getElementsByRef: getElementsByRef$7,
      getRefs: getRefs$6
    } = window.PoleneLibs.Refs;
    const {
      storeLanguage
    } = window.PoleneLibs.ConstantsDate;
    var componentNewsletterSignup = () => {
      const {
        newsletterSignup
      } = getElementsByRef$7('newsletter-signup');
      const newsletterSignups = Array.isArray(newsletterSignup) ? [...newsletterSignup] : [newsletterSignup];
      if (!newsletterSignup || newsletterSignups.length === 0) return;
      const cleaners = [];
      newsletterSignups.forEach(signupContainer => {
        const {
          signupForm,
          formInput,
          messageContainer
        } = getRefs$6(signupContainer);
        const {
          messageSuccess,
          messageError,
          messageAlreadySubscribed,
          messageNotValidEmail,
          klaviyoEventKey
        } = signupForm.dataset;
        if (!messageContainer || !signupForm || !formInput) return;
        const init = () => {
          setEventListeners();
        };
        const setEventListeners = () => {
          signupForm.addEventListener('submit', handleSubmit);
        };
        const removeEventListeners = () => {
          signupForm.removeEventListener('submit', handleSubmit);
        };
        const handleSubmit = async e => {
          e.preventDefault();
          if (!formInput) return;
          if (!validateEmail(formInput.value)) {
            messageContainer.innerHTML = `<p class="ts-error">${messageNotValidEmail}</p>`;
            return;
          }
          const formData = new FormData();
          formData.set('email', formInput.value);
          formData.set('locale', storeLanguage);
          if (klaviyoEventKey) formData.set('event', klaviyoEventKey);
          try {
            const response = await fetch(`${API_PROXY.MARKETING_SUBSCRIBE}`, {
              method: 'POST',
              body: formData
            });
            handleResponse(response);
          } catch {
            messageContainer.innerHTML = `<p class="ts-error">${messageError}</p>`;
          }
        };
        const handleResponse = async res => {
          if (res.status === 200) {
            messageContainer.innerHTML = `<p>${messageSuccess}</p>`;
            const event = new CustomEvent(events$7.NEWSLETTER_SUBSCRIBED, {
              detail: {
                source: 'footer'
              }
            });
            window.dispatchEvent(event);
          } else if (res.status === 409) {
            messageContainer.innerHTML = `<p>${messageAlreadySubscribed}</p>`;
          } else {
            messageContainer.innerHTML = `<p class="ts-error">${messageError}</p>`;
          }
          formInput.value = '';
        };
        init();
        cleaners.push(removeEventListeners);
      });
      return () => {
        cleaners.forEach(cleanup => cleanup());
      };
    };

    var componentNewsletterSignup$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: componentNewsletterSignup
    });

    const {
      getElementByRef: getElementByRef$d
    } = window.PoleneLibs.Refs;
    const {
      isMobile: isMobile$3
    } = window.PoleneLibs.Utils;
    const events$6 = window.PoleneLibs.Events.default;
    class ComponentAccordion extends HTMLElement {
      static currentOpenByParent = new Map();
      controller = undefined;
      content = undefined;
      counter = undefined;
      observer = undefined;
      open = false;
      autoClose = false;
      autoCloseMobile = false;
      autoSetHiddenAttribute = false;
      constructor() {
        super();
      }
      connectedCallback() {
        this.controller = new AbortController();
        this.initializeElements();
        this.setupCounter();
        this.setupAccordion();
        this.syncInitialState();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        if (this.buttonEl) {
          this.buttonEl.removeAttribute('data-accordion-initialized');
        }
        if (this.parentContainer) {
          const currentOpen = ComponentAccordion.currentOpenByParent.get(this.parentContainer);
          if (currentOpen === this) {
            ComponentAccordion.currentOpenByParent.delete(this.parentContainer);
          }
        }
      }
      initializeElements = () => {
        const {
          accordionCounter,
          accordionContent
        } = getElementByRef$d(['accordion-counter', 'accordion-content'], this);
        this.content = accordionContent;
        this.counter = accordionCounter;
        this.buttonEl = this.querySelector('button[aria-expanded]') ?? undefined;
        const controlsId = this.buttonEl?.getAttribute('aria-controls') ?? undefined;
        this.contentEl = controlsId ? document.getElementById(controlsId) : undefined;
        this.closeIconEl = this.buttonEl ? this.buttonEl?.querySelector('.icon-close') : undefined;
        this.openIconEl = this.buttonEl ? this.buttonEl?.querySelector('.icon-open') : undefined;
        this.open = this.buttonEl?.getAttribute('aria-expanded') === 'true';
        this.parentContainer = this.parentElement;
        this.autoClose = this.dataset.closeOthers === 'true' || this.parentContainer?.dataset.accordionCloseOthers === 'true';
        this.autoCloseMobile = this.dataset.closeOthersMobile === 'true' || this.parentContainer?.dataset.accordionCloseOthersMobile === 'true';
        this.autoSetHiddenAttribute = this.dataset.autoSetHiddenAttribute === 'true' || this.parentContainer?.dataset.accordionAutoSetHiddenAttribute === 'true';
        if (this.open && this.parentContainer) {
          ComponentAccordion.currentOpenByParent.set(this.parentContainer, this);
        }
      };
      setupCounter = () => {
        if (!this.content || !this.counter) return;
        this.counter.innerText = (this.content.childElementCount ?? 0).toString();
        this.observer = new MutationObserver(() => {
          if (this.content && this.counter) {
            this.counter.innerText = (this.content.childElementCount ?? 0).toString();
          }
        });
        this.observer.observe(this.content, {
          childList: true
        });
      };
      setupAccordion = () => {
        if (!this.buttonEl) return;
        if (this.buttonEl.hasAttribute('data-accordion-initialized')) {
          return;
        }
        this.buttonEl.setAttribute('data-accordion-initialized', 'true');
        this.buttonEl.addEventListener('click', this.onButtonClick, {
          signal: this.controller?.signal
        });
      };
      syncInitialState = () => {
        if (this.open) {
          const grandParentNode = this.buttonEl?.parentNode?.parentNode;
          if (grandParentNode) {
            grandParentNode.classList.add('active');
          }
          this.classList.add('active');
          if (this.contentEl instanceof HTMLElement) {
            this.contentEl.removeAttribute('hidden');
            this.contentEl.classList.remove('hidden');
            this.contentEl.tabIndex = 0;
          }
          if (this.closeIconEl) this.show(this.closeIconEl);
          if (this.openIconEl) this.hide(this.openIconEl);
        } else {
          this.classList.remove('active');
          const grandParentNode = this.buttonEl?.parentNode?.parentNode;
          if (grandParentNode) {
            grandParentNode.classList.remove('active');
          }
          if (this.autoSetHiddenAttribute) {
            if (this.contentEl instanceof HTMLElement) {
              this.contentEl.setAttribute('hidden', '');
              this.contentEl.tabIndex = -1;
            }
          } else {
            if (this.contentEl instanceof HTMLElement) {
              this.contentEl.classList.add('hidden');
              this.contentEl.tabIndex = -1;
            }
          }
          if (this.closeIconEl) this.hide(this.closeIconEl);
          if (this.openIconEl) this.show(this.openIconEl);
        }
      };
      onButtonClick = () => {
        const isMobileViewport = isMobile$3();
        const currentOpen = this.parentContainer ? ComponentAccordion.currentOpenByParent.get(this.parentContainer) : null;
        const closeCurrentOpenDesktop = !isMobileViewport && !this.open && currentOpen && this.autoClose;
        const closeCurrentOpenMobile = isMobileViewport && !this.open && currentOpen && this.autoCloseMobile;
        if (closeCurrentOpenDesktop || closeCurrentOpenMobile) {
          if (currentOpen && currentOpen !== this) {
            currentOpen.toggle(false);
          }
        }
        this.toggle(!this.open);
      };
      toggle = open => {
        if (open === this.open) {
          return;
        }
        this.open = open;
        if (this.parentContainer) {
          if (open) {
            ComponentAccordion.currentOpenByParent.set(this.parentContainer, this);
          } else {
            const currentOpen = ComponentAccordion.currentOpenByParent.get(this.parentContainer);
            if (currentOpen === this) {
              ComponentAccordion.currentOpenByParent.delete(this.parentContainer);
            }
          }
        }
        this.buttonEl?.setAttribute('aria-expanded', `${open}`);
        this.classList.toggle('active', open);
        const grandParentNode = this.buttonEl?.parentNode?.parentNode;
        if (grandParentNode) {
          grandParentNode.classList.toggle('active', open);
        }
        if (open) {
          this.contentEl?.removeAttribute('hidden');
          if (this.autoSetHiddenAttribute) ; else {
            this.contentEl?.classList.remove('hidden');
          }
          if (this.closeIconEl) this.show(this.closeIconEl);
          if (this.openIconEl) this.hide(this.openIconEl);
          if (this.contentEl instanceof HTMLElement) {
            this.contentEl.tabIndex = 0;
            this.contentEl.focus();
          }
          if (this.buttonEl) {
            const titleElement = this.buttonEl.querySelector('.component-accordion__title');
            const accordionTitle = titleElement?.innerText?.trim() || this.buttonEl.innerText?.trim() || '';
            window.dispatchEvent(new CustomEvent(events$6.ACCORDION_OPENED, {
              detail: {
                title: accordionTitle
              }
            }));
          }
        } else {
          if (this.autoSetHiddenAttribute) {
            this.contentEl?.setAttribute('hidden', '');
          } else {
            this.contentEl?.classList.add('hidden');
          }
          if (this.closeIconEl) this.hide(this.closeIconEl);
          if (this.openIconEl) this.show(this.openIconEl);
          if (this.contentEl instanceof HTMLElement) {
            this.contentEl.tabIndex = -1;
          }
        }
      };
      hide = element => {
        element.classList.add('hidden');
        element.ariaHidden = 'true';
      };
      show = element => {
        element.classList.remove('hidden');
        element.ariaHidden = 'false';
      };
      setOpen = () => {
        this.toggle(true);
      };
      setClose = () => {
        this.toggle(false);
      };
      static define = () => {
        if (!customElements.get('component-accordion')) customElements.define('component-accordion', ComponentAccordion);
      };
    }
    var componentAccordion = () => {
      ComponentAccordion.define();
    };

    var componentAccordion$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: componentAccordion
    });

    const {
      getElementsByRef: getElementsByRef$6
    } = window.PoleneLibs.Refs;
    class ComponentTabs extends HTMLElement {
      tabs = [];
      panels = [];
      activePanel = undefined;
      activeTab = undefined;
      isLastInFocusTrap = false;
      constructor() {
        super();
      }
      connectedCallback() {
        this.initializeElements();
        this.setupEventListeners();
        this.setupAccessibility();
      }
      disconnectedCallback() {
        this.removeEventListeners();
      }
      initializeElements = () => {
        const {
          tab,
          tabPanel
        } = getElementsByRef$6(['tab', 'tab-panel'], this);
        if (!tab || !tabPanel) return;
        this.tabs = Array.isArray(tab) ? tab : [tab];
        this.panels = Array.isArray(tabPanel) ? tabPanel : [tabPanel];
        this.activeTab = this.tabs.find(trigger => trigger?.classList.contains('active'));
        this.activePanel = this.panels.find(panel => panel?.classList.contains('active') && this.activeTab?.dataset.panelId === panel.id);
        this.isLastInFocusTrap = this.dataset.isLastInFocusTrap === 'true';
      };
      setupEventListeners = () => {
        this.tabs.forEach(tab => tab?.addEventListener('click', this.handleClick));
      };
      removeEventListeners = () => {
        this.tabs.forEach(tab => tab?.removeEventListener('click', this.handleClick));
      };
      setupAccessibility = () => {
        this.panels.forEach(panel => {
          if (panel) {
            panel.tabIndex = panel.classList.contains('active') ? 0 : -1;
          }
        });
        if (this.isLastInFocusTrap) {
          this.panels.forEach(panel => {
            if (panel && panel.lastElementChild) panel.lastElementChild.setAttribute('data-is-last-focus', 'true');
          });
        }
      };
      handleClick = event => {
        const triggeredTab = event.currentTarget;
        const {
          panelId
        } = triggeredTab.dataset;
        if (triggeredTab === this.activeTab) return;
        this.switchTab(triggeredTab);
        if (panelId) this.switchPanel(panelId);
      };
      switchTab = targetTab => {
        if (this.activeTab) {
          this.activeTab.classList.remove('active');
          this.activeTab.ariaSelected = 'false';
        }
        if (!targetTab.classList.contains('active')) {
          targetTab.classList.add('active');
          targetTab.ariaSelected = 'true';
        }
        this.activeTab = targetTab;
      };
      switchPanel = targetPanelId => {
        const newActivePanel = this.panels.find(panel => targetPanelId === panel?.id);
        if (this.activePanel) {
          this.activePanel.classList.remove('active');
          this.activePanel.ariaHidden = 'true';
          this.activePanel.tabIndex = -1;
        }
        if (newActivePanel && !newActivePanel.classList.contains('active')) {
          newActivePanel.classList.add('active');
          newActivePanel.ariaHidden = 'false';
          newActivePanel.tabIndex = 0;
          this.activePanel = newActivePanel;
        }
      };
      static define = () => {
        if (!customElements.get('component-tabs')) {
          customElements.define('component-tabs', ComponentTabs);
        }
      };
    }
    var componentTabs = () => {
      ComponentTabs.define();
    };

    var componentTabs$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        ComponentTabs: ComponentTabs,
        default: componentTabs
    });

    class ComponentSnackbar extends HTMLElement {
      autoHideDuration = 3000;
      hideTimer = undefined;
      showTimer = undefined;
      static snackbarInstances = {};
      static defaultSnackbar = null;
      static activeSnackbar = null;
      static SHOW_DELAY = 300;
      constructor() {
        super();
      }
      connectedCallback() {
        this.autoHideDuration = this.dataset.displayDuration ? +this.dataset.displayDuration : this.autoHideDuration;
      }
      resetActiveSnackbar = () => {
        clearTimeout(this.showTimer);
        this.showTimer = undefined;
        ComponentSnackbar.activeSnackbar?.dismiss();
        ComponentSnackbar.activeSnackbar = null;
      };
      show = innerHTML => {
        const isSnackbarActive = !!ComponentSnackbar.activeSnackbar;
        this.resetActiveSnackbar();
        if (innerHTML) this.innerHTML = innerHTML;
        this.showTimer = setTimeout(() => {
          this.classList.add('active');
          ComponentSnackbar.activeSnackbar = this;
        }, isSnackbarActive ? ComponentSnackbar.SHOW_DELAY : 0);
        this.hideTimer = setTimeout(() => {
          this.resetActiveSnackbar();
        }, isSnackbarActive ? ComponentSnackbar.SHOW_DELAY + this.autoHideDuration : this.autoHideDuration);
      };
      dismiss = () => {
        clearTimeout(this.hideTimer);
        this.classList.remove('active');
        this.hideTimer = undefined;
      };
      static open = ({
        templateId,
        innerHTML
      }) => {
        const selector = `component-snackbar${templateId ? '#snackbar-' + templateId : ''}`;
        let instance = null;
        if (templateId) instance = this.snackbarInstances[templateId] ?? document.body.querySelector(selector);else {
          if (!this.defaultSnackbar) this.defaultSnackbar = document.body.querySelector(selector);
          instance = this.defaultSnackbar;
        }
        if (instance) instance.show(innerHTML);
      };
      static define() {
        if (!customElements.get('component-snackbar')) customElements.define('component-snackbar', ComponentSnackbar);
      }
    }
    var componentSnackbar = () => {
      ComponentSnackbar.define();
    };

    var componentSnackbar$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        ComponentSnackbar: ComponentSnackbar,
        default: componentSnackbar
    });

    const SnackbarTemplate = {
      ERROR: 'error',
      ADD_TO_WISHLIST: 'add-to-wishlist',
      REMOVE_FROM_WISHLIST: 'remove-from-wishlist'
    };

    const {
      getElementByRef: getElementByRef$c
    } = window.PoleneLibs.Refs;
    class ComponentAddToWishlist extends HTMLElement {
      isInWishlist = false;
      constructor() {
        super();
        this.controller = new AbortController();
      }
      connectedCallback() {
        this.controller = new AbortController();
        this.initializeElements();
        this.updateWishlistState();
        this.setupEventListeners();
        this.setupAccessibility();
      }
      disconnectedCallback() {
        this.controller.abort();
      }
      updatedCallback() {
        this.controller.abort();
        this.controller = new AbortController();
        this.initializeElements();
        this.updateWishlistState();
        this.setupEventListeners();
        this.setupAccessibility();
      }
      initializeElements = () => {
        const {
          iconHeartFilled,
          buttonTextAdd,
          buttonTextAlready
        } = getElementByRef$c(['icon-heart-filled', 'button-text-add', 'button-text-already'], this);
        this.buttonTextAdd = buttonTextAdd;
        this.buttonTextAlready = buttonTextAlready;
        this.iconHeartFilled = iconHeartFilled;
        this.productId = this.dataset.productId;
      };
      emitWishlistEvent = eventName => {
        const handle = this.dataset.productHandle;
        if (!handle) {
          return;
        }
        window.dispatchEvent(new CustomEvent(eventName, {
          detail: {
            handle,
            productId: this.productId
          }
        }));
      };
      setupEventListeners = () => {
        this.addEventListener('click', this.handleClick, {
          signal: this.controller.signal
        });
      };
      setupAccessibility = () => {
        this.addEventListener('keydown', e => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.handleClick(e);
          }
        }, {
          signal: this.controller.signal
        });
      };
      updateWishlistState = () => {
        if (!this.productId) return;
        this.isInWishlist = Wishlist.isInWishlist(this.productId);
        this.syncUI();
      };
      syncUI = () => {
        if (this.isInWishlist) {
          this.iconHeartFilled?.classList.remove('hidden');
          this.ariaPressed = 'true';
          if (this.buttonTextAlready && this.buttonTextAdd) {
            this.buttonTextAdd.classList.add('hidden');
            this.buttonTextAlready.classList.remove('hidden');
            this.classList.add('already');
            this.removeAttribute('role');
          }
        } else {
          this.iconHeartFilled?.classList.add('hidden');
          this.ariaPressed = 'false';
          if (this.buttonTextAlready && this.buttonTextAdd) {
            this.buttonTextAdd.classList.remove('hidden');
            this.buttonTextAlready.classList.add('hidden');
            this.classList.remove('already');
            this.setAttribute('role', 'button');
          }
        }
        if (this.dataset.addLabel && this.dataset.removeLabel) this.ariaLabel = this.isInWishlist ? this.dataset.removeLabel : this.dataset.addLabel;
      };
      handleClick = async e => {
        e.preventDefault();
        if (e.target instanceof HTMLAnchorElement) {
          window.location.href = e.target.href;
          return;
        }
        if (this.isInWishlist && this.buttonTextAlready) {
          return;
        }
        if (!this.productId || !this.iconHeartFilled) return;
        this.iconHeartFilled.classList.toggle('hidden', this.isInWishlist);
        if (this.buttonTextAlready && this.buttonTextAdd) {
          this.buttonTextAdd.classList.toggle('hidden');
          this.buttonTextAlready.classList.toggle('hidden');
          this.classList.toggle('already');
        }
        const success = await (this.isInWishlist ? Wishlist.remove(this.productId) : Wishlist.add(this.productId));
        if (success) {
          this.isInWishlist = !this.isInWishlist;
          ComponentSnackbar.open({
            templateId: this.isInWishlist ? SnackbarTemplate.ADD_TO_WISHLIST : SnackbarTemplate.REMOVE_FROM_WISHLIST
          });
          this.emitWishlistEvent(this.isInWishlist ? 'WISHLIST_ADDED' : 'WISHLIST_REMOVED');
        } else ComponentSnackbar.open({
          templateId: SnackbarTemplate.ERROR
        });
        this.syncUI();
      };
      static define = () => {
        if (!customElements.get('component-add-to-wishlist')) customElements.define('component-add-to-wishlist', ComponentAddToWishlist);
      };
    }
    var componentAddToWishlist = () => {
      ComponentAddToWishlist.define();
    };

    var componentAddToWishlist$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: componentAddToWishlist
    });

    const {
      isMobile: isMobile$2
    } = window.PoleneLibs.Utils;
    const {
      getElementsByRef: getElementsByRef$5,
      getElementByRef: getElementByRef$b
    } = window.PoleneLibs.Refs;
    class ComponentQuickAdd extends HTMLElement {
      abortController = undefined;
      variantBtns = [];
      quickAddBtn = null;
      isVariants = false;
      constructor() {
        super();
      }
      connectedCallback() {
        this.abortController = new AbortController();
        this.initializeElements();
        this.setupEventListeners();
      }
      disconnectedCallback() {
        this.abortController?.abort();
      }
      initializeElements = () => {
        const {
          quickAddBtn
        } = getElementByRef$b('quick-add-btn', this);
        const {
          quickAddVariantBtn
        } = getElementsByRef$5('quick-add-variant-btn', this);
        if (!quickAddBtn || !quickAddVariantBtn) return;
        this.variantBtns = Array.isArray(quickAddVariantBtn) ? quickAddVariantBtn : [quickAddVariantBtn];
        this.quickAddBtn = quickAddBtn;
        this.isVariants = quickAddBtn.dataset.isVariants === 'true';
        this.handleQuickAddBtnState();
      };
      setupEventListeners = () => {
        window.addEventListener('resize', this.handleQuickAddBtnState, {
          signal: this.abortController?.signal
        });
        this.variantBtns.forEach(variant => {
          variant.addEventListener('mouseenter', this.handleVariantMouseEnter, {
            signal: this.abortController?.signal
          });
          variant.addEventListener('mouseleave', this.handleVariantMouseLeave, {
            signal: this.abortController?.signal
          });
        });
      };
      handleQuickAddBtnState = () => {
        if (!this.quickAddBtn || this.isVariants === false) return;
        if (isMobile$2()) this.quickAddBtn.disabled = false;else this.quickAddBtn.disabled = true;
      };
      handleVariantMouseEnter = event => {
        const inputs = event.currentTarget.querySelectorAll('input[type="hidden"]');
        inputs.forEach(input => input.disabled = false);
      };
      handleVariantMouseLeave = event => {
        const inputs = event.currentTarget.querySelectorAll('input[type="hidden"]');
        inputs.forEach(input => input.disabled = true);
      };
      static define = () => {
        if (!customElements.get('component-quick-add')) {
          customElements.define('component-quick-add', ComponentQuickAdd);
        }
      };
    }
    var componentQuickAdd = () => {
      ComponentQuickAdd.define();
    };

    var componentQuickAdd$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        ComponentQuickAdd: ComponentQuickAdd,
        default: componentQuickAdd
    });

    const Events = window.PoleneLibs.Events.default;
    const scrollLock$4 = window.PoleneLibs.ScrollLock.default;
    const {
      isMobile: isMobile$1,
      throttle
    } = window.PoleneLibs.Utils;
    const {
      getRefs: getRefs$5
    } = window.PoleneLibs.Refs;
    const {
      morph: morph$2
    } = window.PoleneLibs.DOMMorph;
    const classes$7 = {
      active: 'is-active',
      visible: 'is-visible',
      preorderInput: 'preorder-note'
    };
    const states = {
      variantSelector: 'variant-selector',
      productAdded: 'product-added',
      preorder: 'preorder'
    };
    class ComponentCartNotification extends HTMLElement {
      xDown = null;
      yDown = null;
      isOpen = false;
      isProcessingCartUpdate = false;
      refs = null;
      constructor() {
        super();
        this.controller = new AbortController();
      }
      connectedCallback() {
        this.refs = getRefs$5(this);
        this.controller = new AbortController();
        this.setEventListeners();
      }
      disconnectedCallback() {
        this.controller?.abort();
      }
      setEventListeners() {
        window.addEventListener(Events.CART_UPDATED, this.handleCartUpdated, {
          signal: this.controller?.signal
        });
        document.addEventListener('touchstart', this.handleTouchStart, {
          signal: this.controller?.signal
        });
        document.addEventListener('touchmove', throttle(this.handleTouchMove, TIMEOUTS.DELAY_50), {
          signal: this.controller?.signal
        });
        this.addEventListener('click', this.handleClick, {
          signal: this.controller?.signal
        });
        this.addEventListener('animationend', this.handleAnimationEnd, {
          signal: this.controller?.signal
        });
      }
      handleCartUpdated = async e => {
        if (window.location.pathname.includes('/cart')) {
          this.closePopUp();
          return;
        }
        if (this.isProcessingCartUpdate || !e.detail?.sections['cart-notification-content']) return;
        this.isProcessingCartUpdate = true;
        this.cancelAutoClose();
        let parser = new DOMParser();
        let markup = parser.parseFromString(e.detail.sections['cart-notification-content'], 'text/html');
        let updatedContent = markup.documentElement.querySelector(`[id="cart-notification-product-${e.detail.items[0].key}"]`);
        if (updatedContent) this.morphContent(updatedContent);
        this.openPopUp(states.productAdded);
        setTimeout(() => {
          this.isProcessingCartUpdate = false;
        }, TIMEOUTS.DELAY_500);
      };
      closePopUp = () => {
        this.updateState(false);
        const delay = isMobile$1() ? TIMEOUTS.DELAY_150 : TIMEOUTS.DELAY_600;
        this.classList.remove(classes$7.active);
        this.setAttribute('aria-hidden', 'true');
        this.refs?.notificationProduct?.classList.remove(classes$7.visible);
        this.cancelAutoClose();
        setTimeout(() => {
          this.isProcessingCartUpdate = false;
        }, delay);
      };
      openPopUp = state => {
        this.updateState(true);
        this.dataset.state = state;
        this.classList.add(classes$7.active);
        this.setAttribute('aria-hidden', 'false');
        if (state == states.productAdded || state == states.preorder || state == states.variantSelector) {
          this.refs?.notificationProduct?.classList.add(classes$7.visible);
        }
      };
      updateState = state => {
        this.isOpen = state;
        if (isMobile$1()) {
          scrollLock$4(state);
        }
      };
      morphContent = newContent => {
        if (this.refs?.notificationProduct) morph$2(this.refs.notificationProduct, newContent);
      };
      handleClick = e => {
        const target = e.target;
        const closeBtn = target.closest('[data-ref="close-btn"]');
        const notificationBg = target.closest('[data-ref="notification-bg"]');
        if (closeBtn || notificationBg) {
          this.closePopUp();
          return;
        }
      };
      getTouches = e => {
        return e.touches || e.originalEvent.touches;
      };
      handleTouchStart = e => {
        if (!this.isOpen) return;
        const firstTouch = this.getTouches(e)[0];
        this.xDown = firstTouch.clientX;
        this.yDown = firstTouch.clientY;
      };
      handleTouchMove = e => {
        if (!this.xDown || !this.yDown || !this.isOpen) {
          return;
        }
        const xUp = e.touches[0].clientX;
        const yUp = e.touches[0].clientY;
        const xDiff = this.xDown - xUp;
        const yDiff = this.yDown - yUp;
        if (Math.abs(xDiff) < Math.abs(yDiff)) {
          if (yDiff > 0) {
            return;
          } else {
            this.closePopUp();
          }
        }
        this.xDown = null;
        this.yDown = null;
      };
      handleAnimationEnd = e => {
        if (e.animationName === 'auto-close-notification') {
          this.closePopUp();
        }
      };
      cancelAutoClose = () => {
        this.style.animation = 'none';
        void this.offsetWidth;
        this.style.animation = '';
      };
      static define() {
        if (!customElements.get('component-cart-notification')) {
          customElements.define('component-cart-notification', ComponentCartNotification);
        }
      }
    }
    var componentCartNotification = () => {
      ComponentCartNotification.define();
    };

    var componentCartNotification$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        ComponentCartNotification: ComponentCartNotification,
        default: componentCartNotification
    });

    const {
      getElementByRef: getElementByRef$a
    } = window.PoleneLibs.Refs;
    const {
      breakpoints: breakpoints$2
    } = window.PoleneLibs.Breakpoints;
    class ComponentSeeMore extends HTMLElement {
      controller = undefined;
      button = undefined;
      remaining = undefined;
      mediaQuery = undefined;
      constructor() {
        super();
      }
      connectedCallback() {
        this.controller = new AbortController();
        this.initializeElements();
        this.setupMediaQuery();
        this.setupEventListeners();
      }
      disconnectedCallback() {
        this.controller?.abort();
      }
      initializeElements = () => {
        const {
          seeMoreButton,
          seeMoreRemaining
        } = getElementByRef$a(['see-more-button', 'see-more-remaining'], this);
        this.button = seeMoreButton;
        this.remaining = seeMoreRemaining;
      };
      setupMediaQuery = () => {
        this.mediaQuery = window.matchMedia(`(min-width: ${breakpoints$2.md}px)`);
        this.mediaQuery.addEventListener('change', this.handleViewportChange, {
          signal: this.controller?.signal
        });
      };
      handleViewportChange = () => {
        if (this.button && this.remaining) {
          this.button.setAttribute('aria-expanded', 'false');
          this.remaining.hidden = true;
          this.button.hidden = false;
        }
      };
      setupEventListeners = () => {
        this.button?.addEventListener('click', this.handleToggle, {
          signal: this.controller?.signal
        });
      };
      handleToggle = () => {
        if (!this.button || !this.remaining) return;
        const isExpanded = this.button.getAttribute('aria-expanded') === 'true';
        const newExpandedState = !isExpanded;
        this.button.setAttribute('aria-expanded', String(newExpandedState));
        this.remaining.hidden = !newExpandedState;
        this.button.hidden = newExpandedState;
      };
      static define = () => {
        if (!customElements.get('component-see-more')) {
          customElements.define('component-see-more', ComponentSeeMore);
        }
      };
    }
    var componentSeeMore = () => {
      ComponentSeeMore.define();
    };

    var componentSeeMore$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: componentSeeMore
    });

    const scrollLock$3 = window.PoleneLibs.ScrollLock.default;
    const events$5 = window.PoleneLibs.Events.default;
    class ThemeSearchOverlay extends HTMLElement {
      abortController = undefined;
      searchInput = null;
      closeBtn = null;
      focusTrap = undefined;
      constructor() {
        super();
      }
      connectedCallback() {
        this.abortController = new AbortController();
        this.focusTrap = new FocusTrap(this);
        this.initializeElements();
        this.setupEventListeners();
      }
      disconnectedCallback() {
        this.abortController?.abort();
      }
      initializeElements = () => {
        this.searchInput = this.querySelector('input[type="search"]');
        this.closeBtn = this.querySelector('[data-ref="search-overlay-close"]');
      };
      setupEventListeners = () => {
        this.closeBtn?.addEventListener('click', this.handleClose, {
          signal: this.abortController?.signal
        });
        window.addEventListener(events$5.SEARCH_OVERLAY_TOGGLED, this.toggleSearchOverlay, {
          signal: this.abortController?.signal
        });
      };
      handleClose = () => {
        this.classList.remove('is-open');
        scrollLock$3(false);
        this.ariaHidden = 'true';
        this.focusTrap?.deactivate();
      };
      toggleSearchOverlay = e => {
        const {
          isOpen
        } = e.detail;
        this.classList.toggle('is-open', isOpen);
        this.ariaHidden = isOpen ? 'false' : 'true';
        if (this.classList.contains('is-open')) {
          this.focusTrap?.activate();
          this.searchInput?.focus();
        } else this.focusTrap?.deactivate();
      };
      static define = () => {
        if (!customElements.get('theme-search-overlay')) {
          customElements.define('theme-search-overlay', ThemeSearchOverlay);
        }
      };
    }
    var themeSearchOverlay = () => {
      ThemeSearchOverlay.define();
    };

    var themeSearchOverlay$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        ThemeSearchOverlay: ThemeSearchOverlay,
        default: themeSearchOverlay
    });

    const {
      getElementByRef: getElementByRef$9
    } = window.PoleneLibs.Refs;
    class WishlistCounter extends HTMLElement {
      counterEl = undefined;
      constructor() {
        super();
      }
      connectedCallback() {
        this.initializeElements();
        this.setupEventListeners();
      }
      disconnectedCallback() {
        this.removeEventListeners();
      }
      initializeElements = async () => {
        const {
          wishlistCounter
        } = getElementByRef$9('wishlist-counter', this);
        this.counterEl = wishlistCounter;
        if (this.counterEl) this.counterEl.innerText = Wishlist.count().toString();
      };
      setupEventListeners = () => {
        Wishlist.setEventListeners(WishlistEvent.UPDATE, this.handleWishlistUpdate);
      };
      removeEventListeners = () => {
        Wishlist.removeEventListeners(WishlistEvent.UPDATE, this.handleWishlistUpdate);
      };
      handleWishlistUpdate = productIds => {
        if (this.counterEl) this.counterEl.innerText = productIds.length.toString();
      };
      static define = () => {
        if (!customElements.get('wishlist-counter')) customElements.define('wishlist-counter', WishlistCounter);
      };
    }
    var wishlistCounter = () => {
      WishlistCounter.define();
    };

    var wishlistCounter$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: wishlistCounter
    });

    const {
      updateBisModal
    } = window.PoleneLibs.Utils;
    class WishlistGrid extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        this.initializeElements();
        this.setupEventListeners();
      }
      disconnectedCallback() {
        this.removeEventListeners();
      }
      initializeElements = async () => {
        this.renderGrid();
      };
      setupEventListeners = () => {
        Wishlist.setEventListeners(WishlistEvent.UPDATE, this.renderGrid);
      };
      removeEventListeners = () => {
        Wishlist.removeEventListeners(WishlistEvent.UPDATE, this.renderGrid);
      };
      renderGrid = async () => {
        const grid = await Wishlist.getHTML();
        if (grid) {
          this.innerHTML = grid;
          this.classList.remove('hidden');
        } else this.classList.add('hidden');
        updateBisModal();
      };
      static define = () => {
        if (!customElements.get('wishlist-grid')) customElements.define('wishlist-grid', WishlistGrid);
      };
    }
    var wishlistGrid = () => {
      WishlistGrid.define();
    };

    var wishlistGrid$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: wishlistGrid
    });

    const {
      getElementByRef: getElementByRef$8
    } = window.PoleneLibs.Refs;
    class WishlistStateBlock extends HTMLElement {
      emptyWishlistText = undefined;
      saveWishlistText = undefined;
      isLoggedIn = false;
      constructor() {
        super();
      }
      connectedCallback() {
        this.initializeElements();
        this.setupEventListeners();
      }
      disconnectedCallback() {
        this.removeEventListeners();
      }
      initializeElements = async () => {
        const {
          wishlistSaveText,
          wishlistEmptyText
        } = getElementByRef$8(['wishlist-save-text', 'wishlist-empty-text'], this);
        this.saveWishlistText = wishlistSaveText;
        this.emptyWishlistText = wishlistEmptyText;
        if (this.emptyWishlistText && this.saveWishlistText) this.isLoggedIn = true;
        this.syncUI();
      };
      setupEventListeners = () => {
        Wishlist.setEventListeners(WishlistEvent.UPDATE, this.syncUI);
      };
      removeEventListeners = () => {
        Wishlist.removeEventListeners(WishlistEvent.UPDATE, this.syncUI);
      };
      syncUI = () => {
        const isEmpty = Wishlist.count() === 0;
        if (this.isLoggedIn) {
          this.emptyWishlistText?.classList.toggle('hidden', !isEmpty);
          this.saveWishlistText?.classList.toggle('hidden', isEmpty);
        } else this.classList.toggle('hidden', !isEmpty);
      };
      static define = () => {
        if (!customElements.get('wishlist-state-block')) customElements.define('wishlist-state-block', WishlistStateBlock);
      };
    }
    var wishlistStateBlock = () => {
      WishlistStateBlock.define();
    };

    var wishlistStateBlock$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: wishlistStateBlock
    });

    const events$4 = window.PoleneLibs.Events.default;
    const {
      getElementByRef: getElementByRef$7
    } = window.PoleneLibs.Refs;
    const classes$6 = {
      visible: 'is-visible',
      constrast: 'has-contrast'
    };
    let type = null;
    let isTouchDevice = !document.getElementsByTagName('html')[0].classList.contains('no-touch');
    var fragmentCursor = () => {
      const {
        cursor
      } = getElementByRef$7('cursor');
      if (!cursor || isTouchDevice) return;
      const init = () => {
        setEventListeners();
      };
      const setEventListeners = () => {
        window.addEventListener(events$4.CHANGE_CURSOR, handleChangeCursor);
        window.addEventListener('mousemove', handleMouseMove);
      };
      const resetCursor = () => {
        document.body.style.cursor = 'auto';
        cursor.classList.remove(classes$6.visible);
      };
      const handleMouseMove = e => {
        const bounds = cursor.getBoundingClientRect();
        const cursorX = e.clientX - bounds.width / 2;
        const cursorY = e.clientY - bounds.height / 2;
        cursor.style.transform = `translate3d(${cursorX}px, ${cursorY}px, 0)`;
      };
      const handleChangeCursor = e => {
        document.body.style.cursor = 'none';
        type = e.detail.type;
        if (type === 'default') {
          resetCursor();
          return;
        }
        if (e.detail.contrast) {
          cursor.classList.add(classes$6.constrast);
        } else {
          cursor.classList.remove(classes$6.constrast);
        }
        cursor.classList.add(classes$6.visible);
        cursor.dataset.type = e.detail.type;
      };
      init();
      return () => {
        window.removeEventListener(events$4.CHANGE_CURSOR, handleChangeCursor);
        window.removeEventListener('mousemove', handleMouseMove);
        document.body.style.cursor = 'auto';
      };
    };

    var fragmentCursor$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: fragmentCursor
    });

    const {
      preorderInputTemplate
    } = window.PoleneLibs.ElementTemplates;
    const events$3 = window.PoleneLibs.Events.default;
    const {
      envelope
    } = window.PoleneLibs.SvgTemplates;
    const {
      dispatchEvent: dispatchEvent$1
    } = window.PoleneLibs.Utils;
    const {
      getElementByRef: getElementByRef$6,
      getElementsByRef: getElementsByRef$4,
      getRefs: getRefs$4
    } = window.PoleneLibs.Refs;
    const classes$5 = {
      hidden: 'is-hidden',
      open: 'is-open',
      disabled: 'is-disabled',
      preorder: 'is-preorder'
    };
    const selectors$3 = {
      option: '.js-option'
    };
    var fragmentOptionSelect = () => {
      const ref = getElementByRef$6(['grid']);
      const {
        customSelect,
        productDetails,
        searchResults
      } = getElementsByRef$4(['custom-select', 'product-details', 'search-results']);
      if (!ref.grid && !customSelect) return;
      let instances = [];
      const refs = getRefs$4(ref.grid, true);
      const initSelects = () => {
        setTimeout(() => {
          const select = Array.isArray(customSelect) ? [...customSelect] : [customSelect];
          const selectElements = refs && refs.current && Array.isArray(refs.current.customSelect) ? [...refs.current.customSelect] : select;
          selectElements.forEach(selectEl => {
            const selectInstance = initSelect(selectEl);
            if (selectInstance) instances.push(selectInstance);
          });
        });
      };
      const initSelect = selectEl => {
        const {
          select,
          options,
          arrowIcon
        } = getRefs$4(selectEl);
        if (!select) return;
        let selected, container, item;
        selected = document.createElement('div');
        selected.setAttribute('class', `p-select__selected ts-label-s`);
        selected.innerHTML = options[select.selectedIndex].innerHTML;
        const buyBar = document.querySelector('.buy-bar__btn-label-text');
        if (buyBar) buyBar.innerHTML = window.translations?.preorder || buyBar.innerHTML;
        container = document.createElement('div');
        container.setAttribute('class', 'p-select__item-list');
        container.classList.add(classes$5.hidden);
        const handleItemClick = e => {
          const optionEl = e.target.closest(selectors$3.option);
          const optionValue = optionEl.getElementsByClassName('option')[0].innerHTML;
          let selectedIndex;
          options.forEach((option, i) => {
            if (option.innerHTML === optionValue) {
              selectedIndex = i;
            }
          });
          if (optionEl.classList.contains(classes$5.disabled)) {
            e.preventDefault();
            handleToggleList(e);
            const handle = selectEl.closest('[data-handle]')?.dataset.handle;
            dispatchEvent$1(window, events$3.TOGGLE_BIS, {
              variantId: options[selectedIndex].value,
              handle
            });
            return;
          }
          select.selectedIndex = selectedIndex;
          if (selectEl.nextElementSibling.querySelector('input#pre-order') !== null) {
            selectEl.nextElementSibling.querySelector('input#pre-order').remove();
            selectEl.nextElementSibling.querySelector('input#pre-order-tag').remove();
            selectEl.nextElementSibling.querySelector('input#pre-order-date').remove();
          }
          if (selectEl.nextElementSibling.parentElement.querySelector('div.preorder-description') !== null) {
            selectEl.nextElementSibling.parentElement.querySelector('div.preorder-description').remove();
          }
          if (optionEl.classList.contains(classes$5.preorder)) {
            const preOrderInputProperty = select[selectedIndex].dataset.pol;
            const preOrderInputValue = select[selectedIndex].dataset.pofd;
            const preOrderDate = select[selectedIndex].dataset.pod;
            selectEl.nextElementSibling.dataset.state = 'preorder';
            selectEl.nextElementSibling.dataset.defaultState = 'preorder';
            let input = preorderInputTemplate(preOrderInputProperty, preOrderInputValue, preOrderDate);
            selectEl.nextElementSibling.innerHTML += input;
            selectEl.nextElementSibling.parentElement.insertAdjacentHTML('beforeend', `<div class="preorder-description"> ${preOrderInputValue} </div>`);
          } else {
            selectEl.nextElementSibling.dataset.state = 'default';
            selectEl.nextElementSibling.dataset.defaultState = 'default';
          }
          options.forEach((option, i) => {
            if (option.innerHTML === e.target.innerHTML) {
              select.selectedIndex = i;
            }
          });
          selected.innerHTML = e.target.innerHTML;
          handleToggleList(e);
        };
        const handleToggleList = e => {
          if (e) {
            e.preventDefault();
            e.stopPropagation();
          }
          container.classList.toggle(classes$5.hidden);
          selectEl.classList.toggle(classes$5.open);
        };
        options.forEach((option, i) => {
          if (i === 0) return;
          let optionInner = '';
          let notifyLabel = option.dataset.notifyLabel;
          let preorderLabel = option.dataset.pol;
          item = document.createElement('div');
          item.addEventListener('click', handleItemClick);
          item.setAttribute('class', 'p-select__item js-option ts-label-s');
          optionInner = `<span class="option">${option.innerHTML}</span>`;
          if (option.dataset.availability === 'false') {
            item.setAttribute('disabled', true);
            item.classList.add('is-disabled');
            optionInner = `<span class="option">${option.innerHTML}</span>
          <div class="option-message">
            <span>${notifyLabel}</span>
           ${envelope}
        </div>`;
          }
          if (option.dataset.availability === 'true' && 'pod' in option.dataset) {
            item.setAttribute('preorder', true);
            item.classList.add('is-preorder');
            optionInner = `<span class="option">${option.innerHTML}</span>
          <div class="option-message">
            <span>${preorderLabel}</span>
        </div>`;
          }
          item.innerHTML = optionInner;
          container.appendChild(item);
        });
        selectEl.insertBefore(selected, arrowIcon);
        selectEl.appendChild(container);
        selected.addEventListener('click', handleToggleList);
        return () => {
          selected.removeEventListener('click', handleToggleList);
        };
      };
      if (productDetails || searchResults) {
        initSelects();
      }
      window.addEventListener(events$3.PRODUCT_CARD_RENDERED, initSelects);
      return () => {
        instances.forEach(teardown => teardown());
      };
    };

    var fragmentOptionSelect$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: fragmentOptionSelect
    });

    const {
      getElementsByRef: getElementsByRef$3
    } = window.PoleneLibs.Refs;
    const scrollLock$2 = window.PoleneLibs.ScrollLock.default;
    const events$2 = window.PoleneLibs.Events.default;
    const classes$4 = {
      open: 'is-open',
      menuOpen: 'menu-open'
    };
    let isOpen = false;
    const update = ref => {
      if (!ref.searchOverlay || !ref.searchInput || !ref.siteHeader || !ref.menu || !ref.searchTrigger || !ref.searchOverlayBackdrop) return;
      const elements = Array.isArray(ref.searchTrigger) ? [...ref.searchTrigger] : [ref.searchTrigger];
      if (Array.isArray(ref.searchOverlay)) return;
      ref.searchOverlay.classList.toggle(classes$4.open, isOpen);
      elements.forEach(element => {
        element.classList.toggle('is-active', isOpen);
      });
      scrollLock$2(isOpen);
      if (isOpen && !Array.isArray(ref.siteHeader) && !Array.isArray(ref.menu) && !Array.isArray(ref.searchOverlayBackdrop)) {
        if (Array.isArray(ref.searchInput)) {
          ref.searchInput.forEach(input => {
            if (input.closest('[data-overlay="search"]')?.classList.contains('is-open')) {
              input.focus();
              input.select();
            }
          });
        } else {
          ref.searchInput.focus();
          ref.searchInput.select();
        }
        ref.siteHeader.style.backgroundColor = 'hsl(var(--white))';
        ref.menu.classList.remove(classes$4.open);
        ref.siteHeader.classList.remove(classes$4.menuOpen);
        document.body.classList.add('search-open');
        ref.searchOverlayBackdrop.classList.add('is-open');
      } else if (!Array.isArray(ref.siteHeader) && !Array.isArray(ref.searchOverlayBackdrop)) {
        ref.siteHeader.style.removeProperty('background-color');
        document.body.classList.remove('search-open');
        ref.searchOverlayBackdrop.classList.remove('is-open');
      }
    };
    const setSearchOverlayOpenState = (ref, doOpen) => {
      if (doOpen === undefined) {
        isOpen = !isOpen;
      } else {
        isOpen = doOpen;
      }
      update(ref);
      window.dispatchEvent(new CustomEvent(events$2.SEARCH_OVERLAY_TOGGLED, {
        detail: {
          isOpen
        }
      }));
    };
    var fragmentSearchTrigger = () => {
      const ref = getElementsByRef$3(['search-trigger', 'search-overlay', 'search-input', 'site-header', 'menu', 'search-overlay-backdrop']);
      if (!ref.searchTrigger) return;
      const elements = Array.isArray(ref.searchTrigger) ? [...ref.searchTrigger] : [ref.searchTrigger];
      const handleClick = () => setSearchOverlayOpenState(ref);
      const handleKeypress = e => {
        if (e.key !== 'Escape') return;
        setSearchOverlayOpenState(ref, false);
      };
      update(ref);
      const teardowns = elements.map(element => {
        element.addEventListener('click', handleClick);
        return () => element.removeEventListener('click', handleClick);
      });
      window.addEventListener('keydown', handleKeypress);
      if (ref.searchOverlayBackdrop && ref.searchOverlayBackdrop instanceof HTMLElement) {
        ref.searchOverlayBackdrop.addEventListener('click', () => setSearchOverlayOpenState(ref, false));
      }
      return () => {
        teardowns.forEach(teardown => teardown());
        window.removeEventListener('keydown', handleKeypress);
        setSearchOverlayOpenState(ref, false);
        if (ref.searchOverlayBackdrop && ref.searchOverlayBackdrop instanceof HTMLElement) {
          ref.searchOverlayBackdrop.removeEventListener('click', () => setSearchOverlayOpenState(ref, false));
        }
      };
    };

    var fragmentSearchTrigger$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: fragmentSearchTrigger,
        setSearchOverlayOpenState: setSearchOverlayOpenState
    });

    const {
      getElementByRef: getElementByRef$5,
      getRefs: getRefs$3
    } = window.PoleneLibs.Refs;
    const scrollLock$1 = window.PoleneLibs.ScrollLock.default;
    const selectors$2 = {
      navItem: '.js-nav-item'
    };
    const classes$3 = {
      hasChildList: 'has-active-child',
      subMenuOpen: 'open-sub-menu',
      open: 'is-open',
      current: 'is-current'
    };
    var fragmentSubMenu = () => {
      const {
        subMenu,
        subMenuClose
      } = getElementByRef$5(['sub-menu', 'sub-menu-close']);
      if (!subMenu || !subMenuClose) return;
      const {
        activeMenus
      } = getRefs$3(subMenu);
      const activeItems = activeMenus ? [...activeMenus] : [];
      const init = () => {
        subMenu.addEventListener('click', handleClick);
        window.addEventListener('resize', closeMenu);
        if (subMenuClose) {
          subMenuClose.addEventListener('click', handleClose);
        }
      };
      const handleClose = () => {
        closeMenu();
      };
      const handleClick = e => {
        e.preventDefault();
        const subMenu = activeItems.length ? activeItems[activeItems.length - 1].parentNode : null;
        const navItem = e.target.closest(selectors$2.navItem);
        if (navItem && !navItem.classList.contains(classes$3.current) && !navItem.classList.contains(classes$3.hasChildList)) {
          const links = navItem.getElementsByTagName('a');
          const url = links[0].getAttribute('href');
          window.location.href = url;
          closeMenu();
        }
        if (!subMenu) return;
        if (subMenu.classList.contains(classes$3.open)) {
          subMenu.classList.remove(classes$3.open);
          document.body.classList.remove(classes$3.subMenuOpen);
          scrollLock$1(false);
        } else {
          subMenu.classList.add(classes$3.open);
          document.body.classList.add(classes$3.subMenuOpen);
          scrollLock$1(true);
        }
      };
      const closeMenu = () => {
        if (activeItems.length > 0) {
          activeItems.forEach(item => {
            item.parentNode.classList.remove(classes$3.open);
          });
        }
        document.body.classList.remove(classes$3.subMenuOpen);
        scrollLock$1(false);
      };
      init();
      return () => {
        subMenu.removeEventListener('click', handleClick);
        window.removeEventListener('resize', closeMenu);
        if (subMenuClose) {
          subMenuClose.removeEventListener('click', handleClose);
        }
      };
    };

    var fragmentSubMenu$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: fragmentSubMenu
    });

    const {
      intersection
    } = window.PoleneLibs.Observer;
    const {
      getElementsByRef: getElementsByRef$2,
      getRefs: getRefs$2
    } = window.PoleneLibs.Refs;
    const zeroPad = x => x.toString().padStart(2, '0');
    const parseBool = str => str && str === 'true' ? true : false;
    const parseTime = time => {
      const minutes = Math.floor(time / 60);
      const seconds = Math.round(time - minutes * 60);
      return `${zeroPad(minutes)}:${zeroPad(seconds)}`;
    };
    var fragmentVideo = () => {
      const {
        video,
        videoNative
      } = getElementsByRef$2(['video', 'video-native']);
      if (!video) return;
      const videos = Array.isArray(video) ? [...video] : [video];
      const handleIntersection = entries => {
        entries.forEach(entry => {
          const {
            isIntersecting,
            target
          } = entry;
          if (isIntersecting) {
            target.src = target.dataset.src;
            observer.unobserve(target);
          }
        });
      };
      const observer = intersection(null, handleIntersection, {
        rootMargin: `500px 0px 500px 0px`,
        threshold: [0]
      });
      if (videoNative) {
        const videos = videoNative ? Array.isArray(videoNative) ? [...videoNative] : [videoNative] : [];
        videos.forEach(videoNative => {
          observer.observe(videoNative);
        });
      }
      videos.map(video => {
        const refs = getRefs$2(video);
        if (refs.vimeoPlayer) {
          const options = {
            ...(refs.vimeoPlayer.dataset.vimeoUrl.includes('vimeo.com') ? {
              url: refs.vimeoPlayer.dataset.vimeoUrl
            } : {
              id: refs.vimeoPlayer.dataset.vimeoUrl
            }),
            byline: false,
            portrait: false,
            title: false,
            responsive: true
          };
          const player = new Vimeo.Player(refs.vimeoPlayer.id, options);
          let duration = 0;
          player.on('timeupdate', e => {
            duration = e.duration;
            if (refs.currentTime) refs.currentTime.textContent = parseTime(e.duration * e.percent);
            if (refs.duration) refs.duration.textContent = parseTime(e.duration);
            if (refs.timeline) {
              refs.timeline.value = e.percent;
              refs.timeline.style.setProperty('--progress', e.percent);
            }
          });
          player.on('volumechange', e => {
            if (refs.volume) refs.volume.value = e.volume;
            if (volume) volume.style.setProperty('--progress', e.volume);
          });
          player.on('loaded', async () => {
            const initVolume = await player.getVolume();
            if (refs.play) refs.play.textContent = parseBool(refs.vimeoPlayer.dataset.vimeoAutoplay) ? 'Pause' : 'Play';
            if (refs.volume) {
              refs.volume.value = initVolume;
              refs.volume.style.setProperty('--progress', initVolume);
            }
          });
          const handlePlay = async ({
            target
          }) => {
            if (target.closest('.controls') && !target.closest('[data-ref="play"]')) return;
            if (await player.getPaused()) {
              player.play();
              if (refs.play) refs.play.textContent = 'Pause';
            } else {
              player.pause();
              if (refs.play) refs.play.textContent = 'Play';
            }
          };
          const handleSeek = e => {
            player.setCurrentTime(parseFloat(e.target.value) * duration);
            if (refs.timeline) refs.timeline.style.setProperty('--progress', parseFloat(e.target.value));
          };
          const handleVolume = e => {
            player.setVolume(parseFloat(e.target.value));
            if (refs.volume) {
              refs.volume.style.setProperty('--progress', parseFloat(e.target.value));
            }
          };
          const handleMute = async () => {
            const volume = await player.getVolume();
            if (refs.mute) {
              if (volume > 0.5) {
                player.setVolume(0);
                refs.mute.dataset.state = 'unmute';
              } else {
                player.setVolume(1);
                refs.mute.dataset.state = 'mute';
              }
            }
          };
          refs.play?.addEventListener('click', handlePlay);
          refs.vimeoPlayer?.addEventListener('click', handlePlay);
          refs.timeline?.addEventListener('input', handleSeek);
          refs.volume?.addEventListener('input', handleVolume);
          refs.mute?.addEventListener('input', handleMute);
        }
        if (refs.videoNative) {
          let isPlaying = parseBool(refs.videoNative.getAttribute('muted')) && parseBool(refs.videoNative.getAttribute('autoplay'));
          let progress = 0;
          const updateUI = () => {
            progress = refs.videoNative.currentTime / refs.videoNative.duration;
            if (refs.timeline) {
              refs.timeline.style.setProperty('--progress', parseFloat(progress.toString()));
              refs.timeline.value = parseFloat(progress.toString());
            }
            if (refs.volume) {
              refs.volume.value = refs.videoNative.muted ? 0 : refs.videoNative.volume;
              refs.volume.style.setProperty('--progress', parseFloat(refs.volume.value));
            }
            if (refs.currentTime) {
              refs.currentTime.textContent = parseTime(refs.videoNative.currentTime);
            }
            if (refs.duration) {
              refs.duration.textContent = parseTime(refs.videoNative.duration);
            }
            if (refs.mute) {
              if (refs.videoNative.muted) {
                refs.mute.dataset.state = 'unmute';
              } else {
                refs.mute.dataset.state = 'mute';
              }
            }
            if (refs.play) {
              if (isPlaying) {
                refs.play.textContent = 'Pause';
              } else {
                refs.play.textContent = 'Play';
              }
            }
            if (isPlaying) requestAnimationFrame(updateUI);
          };
          updateUI();
          const handlePlay = ({
            target
          }) => {
            if (target.closest('.controls') && !target.closest('[data-ref="play"]')) return;
            isPlaying = !isPlaying;
            if (isPlaying) {
              refs.videoNative.play();
            } else {
              refs.videoNative.pause();
            }
            updateUI();
          };
          const handleSeek = e => {
            refs.videoNative.currentTime = e.target.value * refs.videoNative.duration;
            updateUI();
          };
          const handleVolume = e => {
            refs.videoNative.muted = false;
            refs.videoNative.volume = e.target.value;
            updateUI();
          };
          const handleMute = () => {
            const muted = parseBool(refs.videoNative.getAttribute('muted'));
            refs.videoNative.setAttribute('muted', !muted);
            refs.videoNative.muted = !muted;
            updateUI();
          };
          if (refs.play) {
            video?.addEventListener('click', handlePlay);
          }
          refs.volume?.addEventListener('input', handleVolume);
          refs.mute?.addEventListener('click', handleMute);
          refs.timeline?.addEventListener('input', handleSeek);
        }
      });
    };

    var fragmentVideo$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: fragmentVideo
    });

    const events$1 = window.PoleneLibs.Events.default;
    const {
      dispatchEvent
    } = window.PoleneLibs.Utils;
    const {
      getElementByRef: getElementByRef$4
    } = window.PoleneLibs.Refs;
    const classes$2 = {
      announcementBarActive: 'announcement-bar-active',
      appear: 'appear'
    };
    var sectionAnnouncementBar = () => {
      const {
        announcementBar,
        siteHeader
      } = getElementByRef$4(['announcement-bar', 'site-header']);
      if (!announcementBar || !siteHeader) return;
      const init = () => {
        document.body.style.setProperty('--header-top-pos', '30px');
        siteHeader.classList.add(classes$2.announcementBarActive);
        document.body.classList.add(classes$2.announcementBarActive);
        announcementBar.classList.add(classes$2.appear);
        dispatchEvent(window, events$1.ANNOUNCEMENT_BAR_RENDERED);
      };
      init();
    };

    var sectionAnnouncementBar$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: sectionAnnouncementBar
    });

    const {
      breakpoints: breakpoints$1
    } = window.PoleneLibs.Breakpoints;
    const {
      getElementsByRef: getElementsByRef$1,
      getRefs: getRefs$1
    } = window.PoleneLibs.Refs;
    const selectors$1 = {
      item: '.js-teaser-item'
    };
    const classes$1 = {
      reveal: 'reveal',
      active: 'is-active'
    };
    var sectionArticleTeaser = () => {
      const {
        articleTeaser
      } = getElementsByRef$1(['article-teaser']);
      if (!articleTeaser) return;
      const articleTeasers = Array.isArray(articleTeaser) ? articleTeaser : [articleTeaser];
      articleTeasers.forEach(teaser => {
        let interval;
        let currentIdx = 0;
        let lastIdx = 0;
        let mobileIndex = 0;
        let mobileInterval;
        const {
          previewImages,
          items,
          articleTeaserItem
        } = getRefs$1(teaser);
        const init = () => {
          setEventlisteners();
        };
        const setEventlisteners = () => {
          teaser.addEventListener('mouseover', handleMouseOver);
        };
        const handleMouseOver = e => {
          const item = e.target instanceof Element ? e.target.closest(selectors$1.item) : null;
          if (item) {
            const activeIdx = item.dataset.index ? item.dataset.index : 0;
            const links = items ? Array.from(items) : [];
            links.forEach(link => {
              if (link == item) {
                link.classList.add(classes$1.active);
              } else {
                link.classList.remove(classes$1.active);
              }
            });
            if (lastIdx === activeIdx) return;
            lastIdx = activeIdx;
            stopCounter();
            revealImage(previewImages, activeIdx);
            if (item.dataset.imageAmount) {
              const imageAmount = item.dataset.imageAmount;
              const preview = previewImages.find(p => p?.dataset?.index === activeIdx);
              const {
                revealImages
              } = getRefs$1(preview);
              if (revealImages.length) {
                revealImage(revealImages, 0);
                interval = setInterval(() => {
                  if (currentIdx == imageAmount - 1) {
                    currentIdx = 0;
                  } else {
                    currentIdx = currentIdx + 1;
                  }
                  revealImage(revealImages, currentIdx);
                }, 1800);
              }
            }
          }
        };
        const stopCounter = () => {
          clearInterval(interval ?? undefined);
        };
        if (window.innerWidth <= breakpoints$1.md) {
          const updateClasses = () => {
            previewImages.forEach((item, idx) => {
              const reveal = idx === mobileIndex;
              item.classList.toggle('reveal', reveal);
              item.firstElementChild?.classList.add('reveal');
              articleTeaserItem[idx].classList.toggle('reveal', reveal);
            });
          };
          updateClasses();
          mobileInterval = setInterval(() => {
            mobileIndex = (mobileIndex + 1) % previewImages.length;
            updateClasses();
          }, 3200);
        }
        const revealImage = (images, idx) => {
          images.forEach(img => {
            if (img.dataset.index == idx) {
              img.classList.add(classes$1.reveal);
            } else {
              img.classList.remove(classes$1.reveal);
            }
          });
        };
        init();
        return () => {
          teaser.removeEventListener('mouseover', handleMouseOver);
          if (mobileInterval) clearInterval(mobileInterval);
        };
      });
    };

    var sectionArticleTeaser$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: sectionArticleTeaser
    });

    const {
      breakpoints
    } = window.PoleneLibs.Breakpoints;
    const events = window.PoleneLibs.Events.default;
    const scrollLock = window.PoleneLibs.ScrollLock.default;
    const {
      getElementByRef: getElementByRef$3,
      getRefs,
      ref
    } = window.PoleneLibs.Refs;
    const KeyboardNavigationHook = window.PoleneLibs.KeyboardNavigationHook;
    const selectors = {
      item: '.js-item',
      menuToggle: '.js-menu-toggle',
      faveCounter: '.js-fave-counter',
      subNavTitle: '.js-sub-nav-title'
    };
    const classes = {
      item: 'js-item',
      menuOpen: 'menu-open',
      scrolled: 'is-scrolled',
      open: 'is-open',
      announcementBarActive: 'announcement-bar-active',
      reveal: 'reveal',
      active: 'is-active'
    };
    const isMobile = () => window.innerWidth < breakpoints.md;
    const isSmall = () => window.innerWidth < breakpoints.sm;
    const isScrolled = (scrollHeight = null) => window.scrollY > (isMobile() ? 0 : scrollHeight ?? 30);
    var sectionHeader = () => {
      const {
        siteHeader,
        closeMenu
      } = getElementByRef$3(['site-header', 'close-menu']);
      if (!siteHeader || !closeMenu) return;
      const hasAnnouncementBar = siteHeader?.classList.contains(classes.announcementBarActive);
      const {
        menu,
        menuItem,
        imageLink,
        hoverImg,
        subNavTitle
      } = getRefs(siteHeader);
      const headerItems = Array.from(menu.querySelectorAll('li[data-level="1"]'));
      const imageLinks = imageLink ? [].concat(imageLink) : [];
      const hoverImages = hoverImg ? [].concat(hoverImg) : [];
      const menuItems = menuItem ? [].concat(menuItem) : [];
      const subNavTitles = subNavTitle ? [].concat(subNavTitle) : [];
      let timer = null;
      let activeDropdown = null;
      let activeContainer = null;
      let triggerElem = null;
      let containerFocusable = null;
      const init = () => {
        setEventListeners();
        handleScroll();
      };
      const handleResize = () => {
        handleScroll();
      };
      const setEventListeners = () => {
        window.addEventListener('scroll', handleScroll, {
          passive: true
        });
        window.addEventListener('resize', handleResize, {
          passive: true
        });
        window.addEventListener('keydown', handleKeyDown);
        window.addEventListener(events.CART_UPDATED, updateCartCount);
        window.addEventListener(events.ANNOUNCEMENT_BAR_RENDERED, setCSSVariables);
        menuItems.forEach(item => {
          if (item.classList.contains(classes.active) && isMobile()) {
            if (item.dataset.level == '3') {
              const firstLevel = item.closest('[data-level="1"]');
              const subNav = item.closest('ul');
              const secondLevel = subNav?.previousElementSibling;
              firstLevel?.setAttribute('aria-expanded', 'true');
              if (secondLevel && subNav) {
                toggleSubNav(secondLevel, subNav);
              }
            } else {
              item.setAttribute('aria-expanded', 'true');
            }
          }
          if (item.dataset.level === '1' && item.dataset.children && +item.dataset.children > 0) {
            item.addEventListener('mouseenter', handleOpenDropdown);
            item.addEventListener('mouseleave', handleCloseDropdown);
            item.addEventListener('click', handleToggleNextLevel);
          }
          if (item.dataset.level === '2') {
            item.addEventListener('click', handleOpenSubNav);
          }
        });
        subNavTitles.forEach(title => {
          title.addEventListener('click', handleCloseSubNav);
        });
        imageLinks.forEach(link => {
          link.addEventListener('mouseenter', e => handleRevealImage(e, true));
          link.addEventListener('mouseleave', e => handleRevealImage(e, false));
        });
        if (closeMenu) {
          closeMenu.addEventListener('click', handleClose);
        }
        siteHeader?.addEventListener('click', handleClick);
      };
      const onKeyboardNavigation = () => {
        headerItems.forEach(item => {
          if (item.getAttribute('data-children') === '0') return;
          const element = item.querySelector('a[data-ref="menu-link"]');
          if (!element) return;
          element.setAttribute('data-url', element.href);
          element.removeAttribute('href');
          element.setAttribute('dataindex', '-1');
          element.classList.add('disabled');
        });
      };
      const onMouseNavigation = () => {
        headerItems.forEach(item => {
          if (item.getAttribute('data-children') === '0') return;
          const element = item.querySelector('a[data-ref="menu-link"]');
          setTimeout(() => {
            if (!element || !element.dataset.url) return;
            element.setAttribute('href', element.dataset.url);
            element.removeAttribute('dataindex');
            element.classList.remove('disabled');
          }, 50);
        });
      };
      const keyboardNavHook = new KeyboardNavigationHook({
        onKeyboardEvent: onKeyboardNavigation,
        onMouseEvent: onMouseNavigation
      });
      const handleToggleNextLevel = e => {
        if (!isMobile()) return;
        const target = e.target;
        const item = target?.closest(selectors.item);
        const subNavTitle = target?.closest(selectors.subNavTitle);
        if (subNavTitle || document.body.classList.contains('search-open')) return;
        item?.setAttribute('aria-expanded', 'true');
      };
      const handleOpenSubNav = e => {
        const item = e.currentTarget;
        const subNav = item?.nextElementSibling;
        if (item && subNav) {
          toggleSubNav(item, subNav);
        }
      };
      const toggleSubNav = (item, subNav) => {
        const expanded = subNav.getAttribute('aria-expanded');
        if (expanded === 'false') {
          subNav.style.maxHeight = subNav.scrollHeight + 'px';
          subNav.style.opacity = '1';
          subNav.setAttribute('aria-expanded', 'true');
          item.classList.add(classes.open);
        } else {
          subNav.style.maxHeight = '0px';
          subNav.style.opacity = '0';
          subNav.setAttribute('aria-expanded', 'false');
          item.classList.remove(classes.open);
        }
      };
      const handleCloseSubNav = () => {
        menuItems.forEach(item => {
          item.setAttribute('aria-expanded', 'false');
        });
      };
      const handleOpenDropdown = e => {
        if (!isMobile() && !document.body.classList.contains('search-open')) {
          if (timer) clearTimeout(timer);
          if (activeDropdown && activeDropdown !== e.target) {
            menuItems.forEach(item => {
              item.setAttribute('aria-expanded', 'false');
            });
          }
          const target = e.target;
          const targetItem = target.tagName != 'LI' ? target.closest('li') : target;
          if (target.tagName != 'LI') triggerElem = targetItem;
          activeDropdown = targetItem;
          activeDropdown?.setAttribute('aria-expanded', 'true');
          siteHeader?.classList.add(classes.menuOpen);
          document.body.classList.add(classes.menuOpen);
          activeContainer = activeDropdown?.querySelector('div[data-ref="nav-containers"]');
          if (!activeContainer) return;
          containerFocusable = Array.from(activeContainer.querySelectorAll('a.ts-tertiary-item'));
          if (containerFocusable.length > 0) containerFocusable[0].focus();
        }
      };
      const handleCloseDropdown = e => {
        if (!isMobile()) {
          if (timer) clearTimeout(timer);
          timer = window.setTimeout(() => {
            e.target?.setAttribute('aria-expanded', 'false');
            siteHeader?.classList.remove(classes.menuOpen);
            document.body.classList.remove(classes.menuOpen);
            activeDropdown = null;
          }, 200);
          activeContainer = null;
          containerFocusable = [];
          if (triggerElem) {
            triggerElem.focus();
            triggerElem = null;
          }
        }
      };
      const handleRevealImage = (e, reveal) => {
        hoverImages.forEach(img => {
          if (img.dataset.media === e.target?.dataset.handle) {
            if (reveal) {
              img.classList.add(classes.reveal);
            } else {
              img.classList.remove(classes.reveal);
            }
          }
        });
      };
      const handleClose = () => {
        menu?.classList.remove(classes.open);
        document.body.classList.remove(classes.open);
        siteHeader?.classList.remove(classes.menuOpen);
        document.body.classList.remove(classes.menuOpen);
        scrollLock(false);
      };
      const handleClick = e => {
        const menuTriggered = menu.contains(document.activeElement);
        const toggle = e.target?.closest(selectors.menuToggle);
        const isMenuOpen = siteHeader?.classList.contains(classes.menuOpen);
        if (menuTriggered && document.activeElement?.hasAttribute('aria-expanded')) handleOpenDropdown(e);
        if (toggle) {
          const header = siteHeader;
          menu?.classList.toggle(classes.open);
          header?.classList.toggle(classes.menuOpen);
          document.body.classList.toggle(classes.open);
          document.body.classList.toggle(classes.menuOpen);
          setSearchOverlayOpenState(ref, false);
          handleColorTheme(!isMenuOpen);
          scrollLock(!isMenuOpen);
        }
      };
      const handleColorTheme = menuOpen => {
        const pageColor = document.body.classList.contains('theme-beige') ? '#EDEAE7' : 'transparent';
        const metaThemeColor = document.querySelector("meta[name='theme-color']");
        if (!metaThemeColor) return;
        if (menuOpen) {
          metaThemeColor.content = '#fff';
        } else {
          metaThemeColor.content = pageColor;
        }
      };
      const handleScroll = () => {
        siteHeader?.classList.toggle(classes.scrolled, isScrolled(hasAnnouncementBar ? 30 : null));
        document.body.classList.toggle(classes.scrolled, isScrolled(hasAnnouncementBar ? 30 : null));
        setCSSVariables();
        setProductDetailsMarginTopCssVariable();
      };
      const handleKeyDown = event => {
        if (event.key === 'Enter') {
          const target = event.target;
          if (target.hasAttribute('aria-expanded')) {
            triggerElem = target;
            handleOpenDropdown(event);
          }
        }
        if (event.key === 'Escape') {
          handleCloseDropdown(event);
          handleCloseSubNav();
        }
        if (event.key == 'Tab') handleTab(event);
      };
      const handleTab = event => {
        if (!containerFocusable) return;
        const isReverseTabbing = event.shiftKey;
        const firstElement = containerFocusable[0];
        const lastElement = containerFocusable[containerFocusable.length - 1];
        const isLeavingDropdown = event.target == firstElement && isReverseTabbing || event.target == lastElement && !isReverseTabbing;
        if (isLeavingDropdown) {
          event.preventDefault();
          triggerElem?.focus();
          handleCloseDropdown(event);
          handleCloseSubNav();
        }
      };
      const calculateTotalHeight = element => {
        if (!element) return 0;
        const rect = element.getBoundingClientRect();
        return Math.floor(rect.height);
      };
      const setCSSVariables = () => {
        const {
          height
        } = siteHeader.getBoundingClientRect();
        const translate = !isScrolled() || isSmall() ? 0 : 20;
        const headerHeight = `${height - translate}px`;
        const fullHeight = hasAnnouncementBar ? `${height - translate + 30}px` : `${height - translate}px`;
        const initHeaderHeight = hasAnnouncementBar ? `${height + 30}px` : `${height}px`;
        document.body.style.setProperty('--init-header-height', initHeaderHeight);
        document.body.style.setProperty('--header-height', headerHeight);
        document.body.style.setProperty('--full-header-height', fullHeight);
        document.body.style.setProperty('--full-height', `${window.innerHeight}px`);
      };
      const setProductDetailsMarginTopCssVariable = () => {
        const {
          height
        } = siteHeader.getBoundingClientRect();
        const translate = !isScrolled() || isSmall() ? 0 : 20;
        const productInfoHeader = document.querySelector('.product-hero-info__header');
        const productInfoMain = document.querySelector('.product-hero-info__main');
        const productInfoBottom = document.querySelector('.product-hero-info__bottom');
        const totalHeight = calculateTotalHeight(productInfoHeader) + calculateTotalHeight(productInfoMain) + calculateTotalHeight(productInfoBottom);
        document.body.style.setProperty('--product-details-margin-top', `${Math.max(0, totalHeight + 55 + (hasAnnouncementBar ? height - translate + 30 : height - translate) - window.innerHeight)}px`);
      };
      const updateCartCount = () => {
        fetchCart();
      };
      init();
      return () => {
        window.removeEventListener(events.CART_UPDATED, updateCartCount);
        window.removeEventListener('scroll', handleScroll);
        window.removeEventListener('resize', handleResize);
        siteHeader?.removeEventListener('click', handleClick);
        menuItems.forEach(item => {
          if (item.dataset.level === '1' && item.dataset.children && +item.dataset.children > 0) {
            item.removeEventListener('mouseenter', handleOpenDropdown);
            item.removeEventListener('mouseleave', handleCloseDropdown);
            item.removeEventListener('click', handleToggleNextLevel);
          }
          if (item.dataset.level === '2') {
            item.removeEventListener('click', handleOpenSubNav);
          }
        });
        subNavTitles.forEach(title => {
          title.removeEventListener('click', handleCloseSubNav);
        });
        imageLinks.forEach(link => {
          const handleMouseEnter = e => handleRevealImage(e, true);
          const handleMouseLeave = e => handleRevealImage(e, false);
          link.removeEventListener('mouseenter', handleMouseEnter);
          link.removeEventListener('mouseleave', handleMouseLeave);
        });
        if (closeMenu) {
          closeMenu.removeEventListener('click', handleClose);
        }
        keyboardNavHook.stop();
      };
    };

    var sectionHeader$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: sectionHeader
    });

    const {
      getElementsByRef,
      getElementByRef: getElementByRef$2
    } = window.PoleneLibs.Refs;
    var sectionCountdownTeaser = () => {
      const {
        countdownTeaser
      } = getElementsByRef('countdown-teaser');
      if (!countdownTeaser) return;
      const countdownTeasers = Array.isArray(countdownTeaser) ? countdownTeaser : [countdownTeaser];
      const cleaners = [];
      countdownTeasers.forEach(teaser => {
        const {
          days,
          hours,
          minutes,
          seconds
        } = getElementByRef$2(['days', 'hours', 'minutes', 'seconds'], teaser);
        const {
          targetDate
        } = teaser.dataset;
        if (!days || !hours || !minutes || !seconds || !targetDate) return;
        const target = new Date(targetDate).getTime();
        if (isNaN(target)) return;
        const updateCountdown = () => {
          const now = Date.now();
          let diff = target - now;
          if (diff <= 0) {
            days.textContent = '00';
            hours.textContent = '00';
            minutes.textContent = '00';
            seconds.textContent = '00';
            return;
          }
          const d = Math.floor(diff / (1000 * 60 * 60 * 24));
          diff -= d * (1000 * 60 * 60 * 24);
          const h = Math.floor(diff / (1000 * 60 * 60));
          diff -= h * (1000 * 60 * 60);
          const m = Math.floor(diff / (1000 * 60));
          diff -= m * (1000 * 60);
          const s = Math.floor(diff / 1000);
          days.textContent = String(d).padStart(2, '0');
          hours.textContent = String(h).padStart(2, '0');
          minutes.textContent = String(m).padStart(2, '0');
          seconds.textContent = String(s).padStart(2, '0');
        };
        updateCountdown();
        const intervalId = setInterval(updateCountdown, 1000);
        const cleanup = () => {
          clearInterval(intervalId);
        };
        cleaners.push(cleanup);
      });
      return () => cleaners.forEach(cleaner => cleaner());
    };

    var sectionCountdownTeaser$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: sectionCountdownTeaser
    });

    const {
      relocateElementIfNeeded: relocateElementIfNeeded$1
    } = window.PoleneLibs.Utils;
    const {
      getElementByRef: getElementByRef$1
    } = window.PoleneLibs.Refs;
    const {
      morph: morph$1
    } = window.PoleneLibs.DOMMorph;
    class ProductRecommendations extends HTMLElement {
      activeFetch = null;
      sectionId = undefined;
      productId = undefined;
      intent = undefined;
      recommendationsPerformed = false;
      url = undefined;
      cache = {};
      onlyWishlistEmpty = false;
      minQtyWishlist = 3;
      isFailover = false;
      slidesContainer = undefined;
      constructor() {
        super();
      }
      connectedCallback() {
        relocateElementIfNeeded$1(this);
        this.initializeElements();
        this.setupEventListeners();
      }
      disconnectedCallback() {
        this.removeEventListeners();
      }
      initializeElements = () => {
        const {
          sectionId,
          productId,
          recommendationsPerformed,
          url,
          intent,
          onlyWishlistEmpty,
          minQtyWishlist,
          isFailover
        } = this.dataset;
        const {
          carouselSlidesContainer
        } = getElementByRef$1('carousel-slides-container', this);
        this.slidesContainer = carouselSlidesContainer;
        this.sectionId = sectionId;
        this.productId = productId;
        this.intent = intent;
        this.recommendationsPerformed = recommendationsPerformed === 'true';
        this.url = url;
        this.onlyWishlistEmpty = onlyWishlistEmpty === 'true';
        this.minQtyWishlist = !!minQtyWishlist ? +minQtyWishlist : this.minQtyWishlist;
        this.isFailover = isFailover === 'true';
        if (!this.recommendationsPerformed) this.render();
      };
      setupEventListeners = () => {
        if (this.onlyWishlistEmpty) Wishlist.setEventListeners(WishlistEvent.UPDATE, this.render);
      };
      removeEventListeners = () => {
        if (this.onlyWishlistEmpty) Wishlist.removeEventListeners(WishlistEvent.UPDATE, this.render);
      };
      render = async () => {
        if (!this.slidesContainer) return;
        if (this.onlyWishlistEmpty && Wishlist.count() >= this.minQtyWishlist) {
          this.classList.remove('visible');
          return;
        }
        if (this.isFailover === true) {
          this.classList.add('visible');
          return;
        }
        const section = await this.requestSection();
        if (!section.success || !section.data) return;
        const parsedDoc = new DOMParser().parseFromString(section.data, 'text/html');
        const newSlidesContainer = parsedDoc.querySelector('[data-ref="carousel-slides-container"]');
        if (newSlidesContainer) {
          morph$1(this.slidesContainer, newSlidesContainer);
          this.classList.add('visible');
        }
      };
      requestSection = async () => {
        const url = `${this.url}&product_id=${this.productId}&section_id=${this.sectionId}&intent=${this.intent}`;
        const cachedResponse = this.cache[url];
        if (cachedResponse) {
          return {
            success: true,
            data: cachedResponse
          };
        }
        this.activeFetch?.abort();
        this.activeFetch = new AbortController();
        try {
          const response = await fetch(url, {
            signal: this.activeFetch?.signal
          });
          if (!response.ok) return {
            success: false,
            status: response.status
          };
          const text = await response.text();
          this.cache[url] = text;
          return {
            success: true,
            data: text
          };
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            return {
              success: false,
              status: 0
            };
          }
          throw error;
        } finally {
          this.activeFetch = null;
        }
      };
      static define = () => {
        if (!customElements.get('product-recommendations')) customElements.define('product-recommendations', ProductRecommendations);
      };
    }
    var sectionProductRecommendations = () => {
      ProductRecommendations.define();
    };

    var sectionProductRecommendations$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        ProductRecommendations: ProductRecommendations,
        default: sectionProductRecommendations
    });

    const {
      relocateElementIfNeeded
    } = window.PoleneLibs.Utils;
    const {
      getElementByRef
    } = window.PoleneLibs.Refs;
    const {
      morph
    } = window.PoleneLibs.DOMMorph;
    class WishlistSlider extends HTMLElement {
      slidesContainer = undefined;
      minQtyWishlist = 3;
      constructor() {
        super();
      }
      connectedCallback() {
        relocateElementIfNeeded(this);
        this.initializeElements();
        this.setupEventListeners();
      }
      disconnectedCallback() {
        this.removeEventListeners();
      }
      initializeElements = () => {
        const {
          carouselSlidesContainer
        } = getElementByRef('carousel-slides-container', this);
        const {
          minQtyWishlist
        } = this.dataset;
        this.slidesContainer = carouselSlidesContainer;
        this.minQtyWishlist = !!minQtyWishlist ? +minQtyWishlist : this.minQtyWishlist;
        if (this.slidesContainer) this.renderSlides();
      };
      setupEventListeners = () => {
        Wishlist.setEventListeners(WishlistEvent.UPDATE, this.renderSlides);
      };
      removeEventListeners = () => {
        Wishlist.removeEventListeners(WishlistEvent.UPDATE, this.renderSlides);
      };
      renderSlides = async () => {
        if (!this.slidesContainer) return;
        const hasEnoughItems = Wishlist.count() >= this.minQtyWishlist;
        if (!hasEnoughItems) {
          this.classList.remove('visible');
          return;
        }
        const slides = await Wishlist.getHTML('slides');
        if (slides && slides.length > 1) {
          const parsedDoc = new DOMParser().parseFromString(slides, 'text/html');
          const tempContainer = this.slidesContainer.cloneNode(false);
          tempContainer.innerHTML = parsedDoc.body.innerHTML;
          morph(this.slidesContainer, tempContainer);
          this.classList.add('visible');
        } else {
          this.classList.remove('visible');
        }
      };
      static define = () => {
        if (!customElements.get('wishlist-slider')) customElements.define('wishlist-slider', WishlistSlider);
      };
    }
    var sectionWishlistSlider = () => {
      WishlistSlider.define();
    };

    var sectionWishlistSlider$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        WishlistSlider: WishlistSlider,
        default: sectionWishlistSlider
    });

    const SAP_DOWNLOAD_BASE_PATHS = {
      invoice: API_PROXY.ORDER_INVOICE,
      credit_note: API_PROXY.ORDER_CREDIT_NOTE
    };
    class InvoiceRedirection extends HTMLElement {
      urlParameters = {};
      constructor() {
        super();
      }
      connectedCallback() {
        this.retrieveUrlParameters();
      }
      retrieveUrlParameters() {
        try {
          const decodedSearch = decodeURIComponent(window.location.search);
          const searchParams = new URLSearchParams(decodedSearch);
          const specificParams = ['type', 'id', 'invoice_name', 'invoice', 'document_key', 'credit_note_name', 'credit_note'];
          specificParams.forEach(param => {
            const value = searchParams.get(param);
            if (value) {
              this.urlParameters[param] = value;
            }
          });
          this.createInvoiceRedirectionString();
        } catch (error) {}
      }
      getUrlParameter(key) {
        return this.urlParameters[key];
      }
      getDownloadType() {
        const typeParam = this.getUrlParameter('type');
        if (typeParam === 'credit_note' || typeParam === 'invoice') {
          return typeParam;
        }
        return 'invoice';
      }
      createInvoiceRedirectionString(invoiceParam, idParam, invoiceNameParam, typeParam) {
        const id = idParam ?? this.getUrlParameter('id') ?? '';
        const downloadType = typeParam === 'credit_note' || typeParam === 'invoice' ? typeParam : this.getDownloadType();
        const basePath = SAP_DOWNLOAD_BASE_PATHS[downloadType];
        if (downloadType === 'invoice') {
          const invoice = invoiceParam ?? this.getUrlParameter('invoice') ?? '';
          const invoiceName = invoiceNameParam ?? this.getUrlParameter('invoice_name') ?? '';
          if (!invoiceName || !id) return null;
          const queryParams = new URLSearchParams();
          queryParams.set('id', id);
          if (invoice) queryParams.set('invoice', invoice);
          const queryString = queryParams.toString();
          const result = `${basePath}/${invoiceName}${queryString ? '?' + queryString : ''}`;
          window.location.href = result;
          return result;
        }
        const documentKey = this.getUrlParameter('credit_note_name') ?? this.getUrlParameter('document_key') ?? '';
        const creditNoteSignature = this.getUrlParameter('credit_note') ?? '';
        if (!documentKey || !creditNoteSignature || !id) return null;
        const queryParams = new URLSearchParams();
        queryParams.set('credit_note', creditNoteSignature);
        queryParams.set('id', id);
        const result = `${basePath}/${documentKey}?${queryParams.toString()}`;
        window.location.href = result;
        return result;
      }
      static define = () => {
        if (!customElements.get('invoice-redirection')) {
          customElements.define('invoice-redirection', InvoiceRedirection);
        }
      };
    }
    var componentSapDownloadRedirection = () => {
      InvoiceRedirection.define();
    };

    var componentSapDownloadRedirection$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        InvoiceRedirection: InvoiceRedirection,
        default: componentSapDownloadRedirection
    });

})();
